import * as React from 'react';

const TicketsIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width={485.307}
        height={532.067}
        viewBox="0 0 363.98 399.05"
        {...props}
    >
        <style>
            {
                '\n        .tickets-illustration_svg__B{fill:#13002c}.tickets-illustration_svg__C{fill:#1d0b30}.tickets-illustration_svg__D{fill:#230f4b}.tickets-illustration_svg__E{fill:#e9b492}.tickets-illustration_svg__F{fill:#fff}\n    '
            }
        </style>
        <defs>
            <clipPath id="tickets-illustration_svg__A">
                <path d="M10 45h353.98v354.051H10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__B">
                <path d="M10 142h334v257.051H10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__C">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__D">
                <path d="M298 282h13v9h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__E">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__F">
                <path d="M170 147h13v13h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__G">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__H">
                <path d="M276 207h12v9h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__I">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__J">
                <path d="M257 233h12v14h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__K">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__L">
                <path d="M239 227h13v11h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__M">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__N">
                <path d="M183 240h13v12h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__O">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__P">
                <path d="M202 245h13v13h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Q">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__R">
                <path d="M220 210h11v12h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__S">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__T">
                <path d="M171 170h13v13h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__U">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__V">
                <path d="M189 157h13v12h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__W">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__X">
                <path d="M255 211h13v12h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Y">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Z">
                <path d="M173 222h11v12h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__a">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__b">
                <path d="M236 202h13v12h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__c">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__d">
                <path d="M276 275h12v13h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__e">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__f">
                <path d="M191 265h12v13h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__g">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__h">
                <path d="M185 180h13v12h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__i">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__j">
                <path d="M230 170h8v7h-8zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__k">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__l">
                <path d="M137 151h3v9h-3zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__m">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__n">
                <path d="M137 253h3v10h-3zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__o">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__p">
                <path d="M137 168h10v12h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__q">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__r">
                <path d="M199 222h12v13h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__s">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__t">
                <path d="M148 265h12v13h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__u">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__v">
                <path d="M216 161h3v2h-3zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__w">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__x">
                <path d="M205 194h12v14h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__y">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__z">
                <path d="M249 191h5v4h-5zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AA">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AB">
                <path d="M210 268h13v12h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AC">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AD">
                <path d="M249 253h11v13h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AE">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AF">
                <path d="M270 254h13v14h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AG">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AH">
                <path d="M137 231h10v11h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AI">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AJ">
                <path d="M276 225h12v11h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AK">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AL">
                <path d="M153 164h12v11h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AM">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AN">
                <path d="M137 278h8v12h-8zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AO">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AP">
                <path d="M224 186h12v12h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AQ">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AR">
                <path d="M296 260h13v11h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AS">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AT">
                <path d="M170 281h12v10h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AU">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AV">
                <path d="M226 253h13v12h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AW">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AX">
                <path d="M207 168h12v12h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AY">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__AZ">
                <path d="M189 203h10v13h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Aa">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ab">
                <path d="M147 213h12v11h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ac">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ad">
                <path d="M137 199h4v13h-4zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ae">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Af">
                <path d="M189 287h11v4h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ag">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ah">
                <path d="M293 236h10v13h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ai">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Aj">
                <path d="M165 194h13v12h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ak">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Al">
                <path d="M255 276h11v12h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Am">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__An">
                <path d="M171 260h11v12h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ao">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ap">
                <path d="M156 240h10v12h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Aq">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ar">
                <path d="M232 277h10v12h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__As">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__At">
                <path d="M207 289h9v2h-9zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Au">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Av">
                <path d="M150 190h12v11h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Aw">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ax">
                <path d="M152 142h11v9h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ay">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Az">
                <path d="M219 233h11v11h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BA">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BB">
                <path d="M321 319h13v11h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BC">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BD">
                <path d="M316 295h13v13h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BE">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BF">
                <path d="M341 316h3v4h-3zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BG">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BH">
                <path d="M299 290h12v5h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BI">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BJ">
                <path d="M287 351h12v13h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BK">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BL">
                <path d="M166 398h6v1.051h-6zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BM">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BN">
                <path d="M282 302h12v12h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BO">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BP">
                <path d="M137 326h12v13h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BQ">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BR">
                <path d="M177 382h13v12h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BS">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BT">
                <path d="M187 382h1v1h-1zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BU">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BV">
                <path d="M137 307h10v11h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BW">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BX">
                <path d="M271 339h6v12h-6zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BY">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__BZ">
                <path d="M265 295h12v13h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ba">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bb">
                <path d="M256 393h14v6.051h-14zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bc">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bd">
                <path d="M216 356h12v13h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Be">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bf">
                <path d="M222 295h12v13h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bg">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bh">
                <path d="M137 366h4v12h-4zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bi">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bj">
                <path d="M302 313h12v12h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bk">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bl">
                <path d="M284 324h14v13h-14zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bm">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bn">
                <path d="M176 353h12v13h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bo">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bp">
                <path d="M306 337h11v12h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bq">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Br">
                <path d="M248 351h12v13h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bs">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bt">
                <path d="M264 318h13v11h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bu">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bv">
                <path d="M158 317h12v12h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bw">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bx">
                <path d="M241 375h11v11h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__By">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Bz">
                <path d="M247 326h13v11h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CA">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CB">
                <path d="M153 291h12v12h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CC">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CD">
                <path d="M194 398h7v1.051h-7zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CE">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CF">
                <path d="M210 333h13v12h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CG">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CH">
                <path d="M195 345h13v12h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CI">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CJ">
                <path d="M267 366h7v12h-7zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CK">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CL">
                <path d="M199 368h12v14h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CM">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CN">
                <path d="M171 290h10v2h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CO">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CP">
                <path d="M170 301h12v11h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CQ">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CR">
                <path d="M140 382h11v12h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CS">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CT">
                <path d="M227 319h13v11h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CU">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CV">
                <path d="M189 307h12v13h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CW">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CX">
                <path d="M189 290h11v8h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CY">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__CZ">
                <path d="M162 338h12v11h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ca">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cb">
                <path d="M179 326h12v11h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cc">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cd">
                <path d="M216 385h12v12h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ce">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cf">
                <path d="M156 368h12v12h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cg">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ch">
                <path d="M207 316h13v11h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ci">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cj">
                <path d="M230 344h10v12h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ck">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cl">
                <path d="M244 299h12v11h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cm">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cn">
                <path d="M207 290h10v10h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Co">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cp">
                <path d="M144 348h10v12h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cq">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cr">
                <path d="M75 250h12v13H75zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cs">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ct">
                <path d="M21 203h11v13H21zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cu">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cv">
                <path d="M110 186h13v12h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cw">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cx">
                <path d="M57 237h12v14H57zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cy">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Cz">
                <path d="M97 207h12v13H97zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DA">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DB">
                <path d="M46 167h12v13H46zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DC">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DD">
                <path d="M99 148h11v6H99zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DE">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DF">
                <path d="M37 245h12v13H37zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DG">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DH">
                <path d="M104 288h10v3h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DI">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DJ">
                <path d="M111 240h14v13h-14zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DK">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DL">
                <path d="M18 229h12v12H18zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DM">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DN">
                <path d="M116 215h13v11h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DO">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DP">
                <path d="M91 239h13v12H91zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DQ">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DR">
                <path d="M73 174h12v12H73zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DS">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DT">
                <path d="M16 248h13v11H16zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DU">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DV">
                <path d="M68 196h12v13H68zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DW">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DX">
                <path d="M90 186h12v13H90zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DY">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__DZ">
                <path d="M35 215h11v13H35zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Da">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Db">
                <path d="M128 151h10v9h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dc">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dd">
                <path d="M128 252h10v11h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__De">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Df">
                <path d="M135 170h3v9h-3zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dg">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dh">
                <path d="M46 282h12v9H46zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Di">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dj">
                <path d="M25 268h13v12H25zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dk">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dl">
                <path d="M76 221h12v13H76zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dm">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dn">
                <path d="M56 211h11v12H56zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Do">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dp">
                <path d="M134 232h4v9h-4zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dq">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dr">
                <path d="M134 279h4v11h-4zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ds">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dt">
                <path d="M95 160h11v13H95zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Du">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dv">
                <path d="M27 167h12v11H27zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dw">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dx">
                <path d="M82 160h4v5h-4zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dy">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Dz">
                <path d="M130 200h8v12h-8zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EA">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EB">
                <path d="M45 194h13v10H45zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EC">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__ED">
                <path d="M94 262h12v12H94zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EE">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EF">
                <path d="M56 158h5v2h-5zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EG">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EH">
                <path d="M115 166h11v11h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EI">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EJ">
                <path d="M29 184h10v11H29zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EK">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EL">
                <path d="M53 262h10v12H53zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EM">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EN">
                <path d="M115 273h10v10h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EO">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EP">
                <path d="M136 332h2v2h-2zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EQ">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__ER">
                <path d="M97 353h13v11H97zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__ES">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__ET">
                <path d="M92 333h8v12h-8zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EU">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EV">
                <path d="M134 307h4v9h-4zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EW">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EX">
                <path d="M103 290h13v10h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EY">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__EZ">
                <path d="M128 365h10v13h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ea">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Eb">
                <path d="M117 396h11v3.051h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ec">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ed">
                <path d="M115 322h13v11h-13zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ee">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ef">
                <path d="M47 290h3v1h-3zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Eg">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Eh">
                <path d="M94 390h11v9.051H94zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ei">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ej">
                <path d="M113 375h12v11h-12zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ek">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__El">
                <path d="M119 344h10v11h-10zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Em">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__En">
                <path d="M97 309h11v12H97zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Eo">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Ep">
                <path d="M88 373h10v10H88zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Eq">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Er">
                <path d="M122 297h11v11h-11zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Es">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Et">
                <path d="M86 291h10v12H86zm0 0" />
            </clipPath>
            <clipPath id="tickets-illustration_svg__Eu">
                <path d="M10.285 222.199c0 97.672 79.18 176.852 176.852 176.852s176.848-79.18 176.848-176.852-79.18-176.848-176.848-176.848S10.285 124.527 10.285 222.199" />
            </clipPath>
        </defs>
        <path
            d="M26.738 166.234c-5.852 15.492-17.902 30.352-20.312 43.582S-1.84 240.953.57 254.727s5.207 31.676 18.273 32.711 28.898 8.953 38.887-2.066"
            className="tickets-illustration_svg__D"
        />
        <path
            d="M10.766 243.504c-.09-3.93-3.187-5.152-6.277-5.363-1.492-.102-2.828.176-3.883.813-.355 2.813-.574 5.582-.59 8.273 1.023.863 2.387 1.25 3.715 1.383 4.223-.004 7.137-.855 7.035-5.105m4.129-26.15c-.281-2.914-1.754-6.191-5.988-5.805-1.398-.07-2.32.191-2.945.66l-1.508 6.945c.305 2.531 2.547 2.91 4.777 2.934 3.047.031 5.973-1.52 5.664-4.734m-1.219 50.704c.113-3.453-1.508-5.301-2.035-5.344-7-.352-7.16 2.367-7.18 5.348-.02 3.082.473 5.621 4.41 5.305 3.223-.262 4.703-2.164 4.805-5.309"
            className="tickets-illustration_svg__B"
        />
        <g clipPath="url(#tickets-illustration_svg__A)">
            <path
                d="M363.984 222.199c0 97.672-79.18 176.852-176.852 176.852S10.285 319.871 10.285 222.199 89.465 45.352 187.133 45.352 363.985 124.528 363.985 222.2"
                fill="#EDECF1"
            />
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__B)"
            className="tickets-illustration_svg__D"
        >
            <g clipPath="url(#tickets-illustration_svg__C)">
                <path d="M37.684 151.922s-5.09-1.184-10.945 14.313-17.902 30.352-20.312 43.582-8.266 31.137-5.855 44.91 5.207 31.676 18.273 32.711 28.898 8.953 38.887-2.066 10.328-6.887 19.625-13.773 6.543-11.02 13.086-11.363c0 0-8.609 26.516 0 53.371s-6.199 85.445-6.199 85.445h191.449s-.687-26.562-7.922-34.141.691-10.328-4.129-23.07-12.398-24.445-8.266-35.121c0 0 6.199 20.316 15.84 30.645l13.086 43.73 59.223-64.043s-3.746-28.926-10.48-32.023-47.18-75.211-47.18-75.211-12.93-1.691-27.047-11.445-15.148-12.855-15.148-12.855-5.512-12.395-21.695-21.348-63.375-21.695-63.375-21.695-13.023-.246-17.52 7.969c0 0-8.285 3.492-19.992 0s-24.793-1.426-31.68 5.805-18.594 24.793-18.594 24.793 3.375-14.988-2.445-17.996-30.684-11.121-30.684-11.121" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__D)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__E)">
                <path d="M305.219 282.742c-4.426.109-6.699 3.832-6.383 5.91.078.527.246 1.156.477 1.801h11.051a7.3 7.3 0 00.258-2.391c-.211-3.687-2.785-4.824-5.402-5.32" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__F)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__G)">
                <path d="M176.977 147.891c-4.52-.164-6.102 3.453-6.008 7.02.078 2.852 2.246 5.094 5.617 4.879 3.816.188 6.137-2.641 6.164-5.191.023-2.316-1.117-5.027-3.508-6.164l-1.605-.484a5.256 5.256 0 00-.66-.059" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__H)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__I)">
                <path d="M276.289 211.023c-.969 4.52 2.609 4.762 5.785 4.938 2.523.145 5.031-.34 5.563-3.004l-1.773-3.141s-3.48-.461-8.801-2.258c-.574.973-.922 2.137-.773 3.465" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__J)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__K)">
                <path d="M262.813 233.914c-3.031-.465-5.867 2.484-5.707 5.922.152 3.141 2.465 5.359 6.637 6.586 1.766-2.191 5.094-4.531 5.094-6.867 0-1.992-3.637-5.277-6.023-5.641" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__L)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__M)">
                <path d="M245.676 237.98c3.938.25 5.77-2.164 5.941-5.645.18-3.598-2.109-5.133-7.695-4.93-1.25.102-4.586 1.164-4.375 4.969.164 3.039 2.617 5.387 6.129 5.605" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__N)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__O)">
                <path d="M189.113 251.313c2.715-.086 6.492-1.262 6.34-5.727-.125-3.75-1.961-5.367-5.637-5.008-3.703-.32-5.953 1.094-6.031 5.066-.07 3.637 2.91 5.742 5.328 5.668" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__P)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Q)">
                <path d="M208.773 257.781c2.449.328 5.164-2.672 5.234-6.383-.27-3.734-2.617-5.609-6.133-5.434-3.211.156-5.574 1.941-5.453 5.652.137 4.035 3.973 5.848 6.352 6.164" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__R)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__S)">
                <path d="M220.129 215.855c.008 2.828.359 6.145 4.508 5.445 3.824.246 5.766-1.02 6.078-4.937.348-4.383-2.613-6.062-5.648-6.328-3.211-.277-4.949 2.777-4.937 5.82" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__T)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__U)">
                <path d="M176.141 182.152c2.879-.988 5.168-3.707 7.438-5.551-.914-4.387-3.582-6.305-6.281-6.164-2.883.152-6.52 2.195-6.07 5.578.313 2.355 3.984 6.453 4.914 6.137" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__V)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__W)">
                <path d="M195.777 157.922c-3.859-.336-5.574 1.246-5.781 5.313-.223 4.355 3.492 4.898 5.551 4.984 2.797.113 6.047-1.453 6.004-5.488-.035-3.836-2.172-5.215-5.773-4.809" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__X)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Y)">
                <path d="M260.93 211.586c-3.984-.773-3.937 3.125-5.707 4.934 1.977 1.73 1.176 6.168 5.617 5.543 3.273-.457 6.746-1.211 6.344-5.133-.297-2.922-2.078-6.02-6.254-5.344" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Z)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__a)">
                <path d="M183.84 228.262c.238-2.914-1.184-6.078-4.5-5.969-3.633.125-5.805 2.895-5.918 6.684-.113 3.707 2.203 4.809 5.91 4.648 4.492 1.273 4.293-2.723 4.508-5.363" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__b)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__c)">
                <path d="M242.941 213.215c4.23 1.77 5.82-2.602 5.727-4.496-.156-3.121-3.012-5.891-6.699-5.762-2.691.094-5.457 2.145-4.98 4.793.453 2.504.754 6.961 5.953 5.465" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__d)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__e)">
                <path d="M287.641 282.52c.746-5.609-3.844-7.648-4.59-7.289-2.687 1.305-6.789 2.375-6.617 6.336.133 2.984 2.563 5.594 5.594 5.5 3.453-.105 5.203-3.012 5.613-4.547" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__f)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__g)">
                <path d="M202.508 272.43c.313-4.172-3.102-6.59-5.344-6.715-2.187-.125-5.586 2.281-5.34 6.195.262 4.129 2.832 5.359 6.473 5.691 4.43.402 3.711-2.91 4.211-5.172" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__h)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__i)">
                <path d="M185.867 186.543c-.148 3.277 2.875 4.379 5.434 4.941 4.109-.254 6.109-3.441 6.34-5.969.156-1.691-3.422-5.297-5.246-5.242-3.082.094-6.363 2.656-6.527 6.27" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__j)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__k)">
                <path d="M236.602 176.184c.168-.012.324-.055.488-.082a55.535 55.535 0 00-6.242-5.93c-.004.07-.027.133-.027.207-.039 2.852 2.742 6.02 5.781 5.805" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__l)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__m)">
                <path d="M137.141 159.465c1.711-.484 2.828-1.625 2.793-4.137-.023-1.727-.418-3.18-1.34-4.137l-1.453.301" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__n)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__o)">
                <path d="M139.992 257.859c-.016-2.625-.977-4.195-2.852-4.762v9.352c1.738-.602 2.867-1.91 2.852-4.59" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__p)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__q)">
                <path d="M141.574 168.84c-1.445.027-3.133.563-4.434 1.555v7.859c1.203.738 2.813 1.02 4.547.797 2.418.004 5.109.727 5.027-3.383-.078-3.746-1.656-6.891-5.141-6.828" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__r)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__s)">
                <path d="M199.805 227.617c-.141 3.473 1.883 5.395 6.613 6.578 1.203-1.984 3.672-4.25 3.652-6.5-.02-2.418-1.5-5.574-5.332-5.617-3.898-.039-4.812 2.52-4.934 5.539" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__t)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__u)">
                <path d="M159.363 271.762c-.031-3.074-1.414-6.773-4.207-6.156-2.496.551-5.359 4.059-6.078 6.789-.781 2.961 2.383 4.707 5.125 5.211 4.156-.152 5.191-2.582 5.16-5.844" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__v)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__w)">
                <path d="M216.234 161.371c.484.383 1.086.648 1.789.816l-1.789-.816" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__x)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__y)">
                <path d="M205.914 200.699c-.27 4.156 1.703 6.297 5.258 6.43 3.766.141 4.781-3.312 5.227-5.957.598-3.543-3.117-4.441-5.301-6.195-1.609 2.133-6.387 1.574-5.184 5.723" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__z)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__AA)">
                <path d="M253.813 194.793l-3.949-3.059c.668 1.539 1.891 2.719 3.949 3.059" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__AB)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__AC)">
                <path d="M222.328 274.75c-.359-2.215-1.059-6.379-5.445-6.039-3.164.246-6.312 1.805-6.254 4.699.063 2.969 2.531 5.676 5.891 6.41 3.32-.488 6.227-2.52 5.809-5.07" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__AD)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__AE)">
                <path d="M254.934 253.629c-2.402.656-4.926 4.094-5.633 6.781-.672 2.559 1.746 4.887 5.023 4.832 3.746-.062 4.922-2.578 5.422-5.414-.152-3.648-2.605-6.805-4.813-6.199" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__AF)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__AG)">
                <path d="M270.992 261.816c-.41 2.293 2.758 5.215 7.227 5.223 2.27-.328 4.02-1.832 4.348-5.109.406-4.023-3.684-4.5-5.156-7.004-2.277 2.27-5.949 4.293-6.418 6.891" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__AH)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__AI)">
                <path d="M146.91 235.711c-.199-3.043-1.387-4.594-4.184-4.031-2.207-.152-4.172.336-5.586 1.297v7.594c1.328.949 2.996 1.465 4.262 1.41 2.137-.094 5.773-2.207 5.508-6.27" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__AJ)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__AK)">
                <path d="M282.785 225.684c-2.867.402-6.441.27-6.516 4.777-.066 4.102 3.16 5.461 5.957 5.531 2.453.059 5.32-1.562 5.758-5.137-.797-2.664-1.367-5.711-5.199-5.172" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__AL)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__AM)">
                <path d="M153.258 169.574c.039 3.559 1.766 5.516 5.984 5.066 3.484 1.141 5.035-1.711 5.168-4.414.152-3.098-2.301-5.871-5.395-5.855-2.66.012-5.797 1.43-5.758 5.203" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__AN)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__AO)">
                <path d="M139.797 278.367c-1.023.055-1.906.492-2.652 1.164v10.082c.75.156 1.594.199 2.449.25 3.273.195 5.492-.789 4.703-4.777 1.094-3.945-2.086-6.84-4.5-6.719" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__AP)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__AQ)">
                <path d="M229.652 197.52c3.645-.055 5.172-2.277 5.344-5.672.188-3.695-1.852-5.039-5.281-4.965-3.707.082-5.457 2.078-5.293 5.684.145 3.23 1.969 5 5.23 4.953" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__AR)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__AS)">
                <path d="M303.754 260.719c-3.934-.355-6.539 2.266-6.816 4.84-.234 2.148 1.883 5.758 6.012 4.934 4.75 1.254 5.25-2.906 5.754-5.551.574-3-1.988-3.957-4.949-4.223" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__AT)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__AU)">
                <path d="M171.504 290.453h8.641c.734-.73 1.184-1.828 1.246-3.48.16-4.246-3.195-5.434-5.93-5.707-2.859-.285-4.582 2.188-4.492 5.406.035 1.422.07 2.805.535 3.781" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__AV)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__AW)">
                <path d="M232.754 264.188c3.004-.016 5.758-2.371 5.645-5.57-.105-2.977-2.57-5.488-5.629-5.57-3.203-.082-4.547 2.934-6.012 5.375.906 3.387 2.996 5.777 5.996 5.766" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__AX)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__AY)">
                <path d="M212.438 168.621c-3.215-.16-4.598 2.754-4.73 5.852-.141 3.297.957 5.445 4.074 4.691 3.559-.246 6.91.438 6.527-4.238-.305-3.711-2.598-6.137-5.871-6.305" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__AZ)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Aa)">
                <path d="M194.227 203.805c-3.781-.027-4.941 2.984-5.055 6.465-.109 3.176.879 5.68 4.324 5.656 3.594-.023 4.977-2.465 4.539-5.984.355-3.031-.145-6.113-3.809-6.137" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Ab)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ac)">
                <path d="M147.125 218.809c.184 3.633 3.285 4.785 6.422 5.07 3.613.332 5.051-1.77 4.992-5.863 1.422-3.863-3.445-2.703-4.867-4.656-2.102 1.961-6.758 1.234-6.547 5.449" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Ad)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ae)">
                <path d="M140.895 205.445c.492-2.715-2.098-5.992-3.469-5.469l-.285.102v11.219c2.383-.457 3.969-2.516 3.754-5.852" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Af)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ag)">
                <path d="M193.887 287.57c-1.98-.297-3.762.738-4.457 2.883h9.926c-.996-1.984-3.613-2.605-5.469-2.883" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Ah)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ai)">
                <path d="M298.402 236.449c-3.559.043-4.469 3.402-4.602 6.852-.148 3.828 2.387 5.063 5.117 5.059 3.359-.004 4.25-2.695 3.793-5.965.992-3.559-1.496-5.984-4.309-5.945" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Aj)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ak)">
                <path d="M177.91 200.648c-.027-3.789-2.184-6.18-4.859-5.551-2.754.648-6.965 3.238-7.07 5.164-.16 3.008 3.895 4.855 7 5.023 2.816.156 4.73-2 4.93-4.637" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Al)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Am)">
                <path d="M255.035 281.438c.199 2.832 1.145 5.625 4.508 5.941 4.262-.047 5.625-3.023 6.109-5.922.559-3.305-2.645-4.484-4.988-4.543-2.57-.066-5.895.75-5.629 4.523" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__An)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ao)">
                <path d="M176.176 271.316c3.141-.18 5.227-1.902 5.203-5.492-.02-3.254-1.34-4.988-4.758-5.039-3.934-.055-5.227 2.078-5.012 6.035-.949 3.523 1.484 4.672 4.566 4.496" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Ap)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Aq)">
                <path d="M160.93 251.871c3.266.074 5.348-2.285 4.93-5.891-.285-2.441.031-5.645-3.883-5.371-3.477.242-5.777 1.867-5.262 6.117-.836 3.281 1.621 5.082 4.215 5.145" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Ar)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__As)">
                <path d="M241.242 281.926c.047-3.219-.469-5.234-4.199-4.324-4.09-.82-4.73 1.594-4.738 4.77-.012 3.34 1.309 6.602 4.59 6.336 2.863-.23 4.301-3.391 4.348-6.781" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__At)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Au)">
                <path d="M211.953 289c-1.859.027-3.266.555-3.988 1.453h8.023c-.812-1.066-2.203-1.477-4.035-1.453" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Av)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Aw)">
                <path d="M150.676 195.875c1.699 1.684 4.145 5.078 4.957 4.727 2.457-1.07 5.996-2.191 5.477-6.484.789-4.078-2.312-3.187-4.855-3.758-5.133-1.148-3.309 4.137-5.578 5.516" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Ax)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ay)">
                <path d="M152.359 145.191c-.312 2.902-.504 5.445 3.699 4.949 3.285-.387 6.367-1.566 6.633-4.863a3.878 3.878 0 00-.238-1.738l-3.855-1.066s-2.926-.055-6.484.762c-.039.516.035 1.156.246 1.957" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Az)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__BA)">
                <path d="M229.027 238.488c.496-3.191-.84-5.039-4.437-4.883-2.672.113-4.789.668-4.648 4.168.133 3.445 1.594 5.953 4.988 6.086 2.926.109 4.395-2.102 4.098-5.371" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__BB)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__BC)">
                <path d="M327.77 319.094c-3.566-.211-6.234.656-6.105 5.004.121 4 2.68 5.371 6.121 5.473 3.613.105 5.957-2.422 5.941-5.441-.02-2.914-2.094-5.562-5.957-5.035" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__BD)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__BE)">
                <path d="M322.078 295.77c-2.645.941-5.469 2.625-5.539 5.867-.066 3.035 2.617 5.68 5.453 5.531 2.75-.145 7.102-1.027 6.492-5.184-.395-2.687-2.027-5.98-6.406-6.215" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__BF)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__BG)">
                <path d="M343.395 316.125c-1.16.656-1.922 1.695-2.039 3.266l2.168-2.34-.129-.926" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__BH)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__BI)">
                <path d="M304.844 294.957c2.605-.301 4.793-1.883 5.516-4.504h-11.047c.809 2.281 2.57 4.844 5.531 4.504" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__BJ)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__BK)">
                <path d="M292.648 363.531c3-.059 5.91-1.523 5.699-5.402-.219-4.016-2.59-6.223-6.504-6.73-4.797-.625-3.5 3.461-3.687 3.922-1.277 5.914.727 8.281 4.492 8.211" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__BL)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__BM)">
                <path d="M166.359 399.051h4.746c-.586-.34-1.187-.621-1.816-.777-1.086-.273-2.105.059-2.93.777" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__BN)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__BO)">
                <path d="M287.492 313.656c3.984 0 5.359-3.082 6.434-5.418.145-4.039-1.035-6.059-4.523-6.102-4.395-.055-6.297 2.855-6.852 6.5-.508 3.324 1.855 5.02 4.941 5.02" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__BP)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__BQ)">
                <path d="M148.492 332.762c.109-2.762-1.609-5.934-8.141-6.25-1.887-.184-1.703 3.586-3.211 5.855v1.453c1.871 1.969 3.629 4.609 5.77 4.973 3.313.559 5.477-3.277 5.582-6.031" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__BR)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__BS)">
                <path d="M183.547 393.434c3.238-.203 5.598-2.656 5.75-6.434.148-3.648-2.086-4.648-1.648-4.68-8.496-.812-9.574 2.633-9.672 5.625-.102 3.051 2.617 5.672 5.57 5.488" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__BT)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__BU)">
                <path
                    d="M187.648 382.32l.238.02"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    stroke="#221F1F"
                    strokeWidth={0.12}
                />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__BV)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__BW)">
                <path d="M142.016 317.766c3.305.352 4.602-2.602 4.816-4.453.176-5.461-2.523-5.98-5.93-6.148-1.48-.074-2.758.215-3.762.777v8.039c1.387 1.035 3.207 1.609 4.875 1.785" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__BX)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__BY)">
                <path d="M271.805 339.344l3.23 10.801c1.055-1.234 1.352-3.367 1.273-6.406-.086-1.352-1.238-4.629-4.504-4.395" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__BZ)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ba)">
                <path d="M266.027 301.461c-.371 2.898 1.266 6.367 6.035 6.039 3.758.793 4.18-1.988 4.258-4.93.102-3.578-1.004-7.285-4.949-6.961-2.031.168-5.051 3.602-5.344 5.852" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Bb)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Bc)">
                <path d="M263.684 393.586c-3.227-.141-6.238.074-6.719 4.227a5.448 5.448 0 000 1.238h12.277a6.63 6.63 0 00.125-1.012c.195-4.527-2.77-4.297-5.684-4.453" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Bd)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Be)">
                <path d="M221.281 368.645c2.75-.266 5.523-3.207 5.742-6.781.23-3.809-2.555-5.043-5.66-5.121-3.559-.09-5.344 1.922-4.945 5.066-.172 4.09 2.242 7.086 4.863 6.836" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Bf)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Bg)">
                <path d="M233.965 301.707c.09-2.285-.914-6.84-5.457-6.047-2.785.484-5.898 1.309-6 6.281.863 2.195 2.406 5.121 5.871 5.418 3.547.305 5.504-3.668 5.586-5.652" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Bh)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Bi)">
                <path d="M140.738 374.91c.355-4.742-1.609-7.355-3.594-8.402v11.125c2.074-.262 3.496-1.965 3.594-2.723" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Bj)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Bk)">
                <path d="M308.504 313.656c-3.18.125-6.277.543-5.945 5.348.289 4.199 2.25 5.488 6.254 5.148 3.703.758 4.484-1.484 4.504-4.77.023-3.402-1.102-5.871-4.812-5.727" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Bl)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Bm)">
                <path d="M290.301 336.109c2.395-.215 4.535-3.363 7.664-5.945-3.062-2.379-5.473-5.684-7.664-5.547-2.148.137-5.332 3.531-5.797 5.934-.621 3.207 3.273 5.785 5.797 5.559" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Bn)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Bo)">
                <path d="M181.777 365.352c2.766-.227 5.414-1.848 5.914-5.211-.488-3.996-3.371-6.504-6.402-6.621-2.703-.105-4.312 3.098-4.41 6.293-.109 3.496 1.566 5.816 4.898 5.539" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Bp)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Bq)">
                <path d="M311.84 337.266c-2.656.629-5.945 1.969-5.699 6.125.219 3.699 2.25 5.172 5.598 5.398 4.652.32 4.098-3.617 4.301-4.027 2.035-6.785-3.223-7.727-4.199-7.496" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Br)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Bs)">
                <path d="M259.188 357.715c-.047-1.887-.402-6.527-4.805-6.301-4.285.223-5.164 3.32-5.41 6.797-.328 3.309 1.32 5.273 4.367 5.398 3.797.16 5.91-3.383 5.848-5.895" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Bt)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Bu)">
                <path d="M276.113 325.367c.672-6.695-4.086-5.098-5.453-7.359-1.836 2.23-6.875.648-6.609 5.168.23 3.906 3.293 5.207 6.68 5.348 3.629.156 5.238-2.16 5.383-3.156" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Bv)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Bw)">
                <path d="M163.699 328.727c3.477-.059 5.75-.957 5.387-4.395.066-4.125-1.414-6.426-5.18-6.355-3.285.063-5.246 1.902-5.305 5.297-.062 3.383 1.168 5.52 5.098 5.453" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Bx)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__By)">
                <path d="M247.598 375.063c-3.297.242-6.324 1.418-6.262 4.742.047 2.664.715 6.105 5.391 6.074 4.262-.031 5.32-1.828 4.957-5.324.094-3.027.266-5.816-4.086-5.492" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Bz)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__CA)">
                <path d="M259.258 331.379l-1.578-3.785c-.75-.629-1.785-1.059-3.191-.996-3.699.16-7.074.617-6.926 4.684.082 2.176 1.254 6.035 5.641 5.125 4.301 1.406 5.355-2.484 6.051-4.992 0-.012 0-.027.004-.035" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__CB)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__CC)">
                <path d="M158.512 302.18c3.59.313 6.289-1.152 5.98-4.879-.262-3.125-2.641-5.324-6.047-5.707-4.441-.496-4.687 3.316-5.027 5.898-.406 3.098 1.621 5.039 5.094 4.688" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__CD)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__CE)">
                <path d="M194.547 399.051h6.063c-.789-.652-1.77-.973-2.883-.859a10.27 10.27 0 00-3.18.859" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__CF)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__CG)">
                <path d="M217.207 344.531c3.523-.285 5.035-3.156 5.297-5.816.359-3.691-3.773-5.711-5.937-5.363-2.254.363-5.371 3.777-5.574 6.078-.187 2.141 2.43 5.273 6.215 5.102" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__CH)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__CI)">
                <path d="M201.078 356.313c2.551-.559 5.551-3.836 6.207-6.445.406-1.613-2.738-4.887-9.09-4.586-.508.043-2.879 2.082-2.578 5.047.281 2.793 2.422 6.652 5.461 5.984" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__CJ)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__CK)">
                <path d="M271.797 377.434c.379-.023.797-.168 1.227-.355-.953-4.078-2.23-7.879-3.961-10.516-1.156.953-1.816 2.629-1.613 4.809-.73 3.367 1.672 6.242 4.348 6.063" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__CL)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__CM)">
                <path d="M204.848 381.102c2.719-2.105 5.18-4.352 5.547-8.113.383-3.984-2.305-3.973-5.012-4.047-3.543-.285-5.863 2.051-5.371 4.836.465 2.645 3.133 4.898 4.836 7.324" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__CN)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__CO)">
                <path d="M175.129 291.621c2.184.156 3.922-.086 5.016-1.168h-8.641c.504 1.059 1.512 1.625 3.625 1.168" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__CP)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__CQ)">
                <path d="M181.375 307.141c.059-3.949-2.109-5.215-6.039-5-3.676-.773-4.645 1.414-4.633 4.941.016 3.332.965 5.063 4.762 4.871 3.406-.172 5.848-.754 5.91-4.812" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__CR)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__CS)">
                <path d="M145.734 393.676c4.117.07 5.133-2.359 5.113-5.801.227-3.273-1.379-5.754-4.492-5.355-2.992.383-5.484 2.527-5.531 6.254-.043 3.383 1.566 4.848 4.91 4.902" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__CT)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__CU)">
                <path d="M239.453 324.746c-.254-3.687-2.043-5.137-6.117-5.02-3.984-1.016-5.375 2.695-5.918 5.594-.211 1.133 3.555 3.012 5.508 4.547 1.715-2.262 6.887.078 6.527-5.121" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__CV)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__CW)">
                <path d="M194.555 319.211c2.691-.266 5.84-2.66 5.582-6.91.418-2.934-.836-4.957-4.176-4.816-3.227.137-5.684 1.176-5.969 5.273-.266 3.801 2.773 6.629 4.563 6.453" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__CX)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__CY)">
                <path d="M194.254 297.824c3.965.402 5.188-2.203 5.48-4.953.105-.977-.051-1.77-.375-2.418h-9.93a6.776 6.776 0 00-.316 2.125c.035 3.926 1.531 5.656 5.141 5.246" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__CZ)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ca)">
                <path d="M173.473 344.285c.277-4.254-2.461-5.605-5.785-5.738-3.121-.125-4.84 2.098-4.937 5.148-.113 3.582 2.32 4.785 4.5 5.113 4.117.145 5.996-1.07 6.223-4.523" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Cb)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Cc)">
                <path d="M185.391 326.852c-4.848-1.207-5.191 3.031-5.633 5.637-.504 2.945 2.121 3.973 5.043 4.141 3.879.223 5.535-1.176 5.418-5.18-.098-3.387-.937-5.43-4.828-4.598" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Cd)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ce)">
                <path d="M222.281 396.156c3.07.266 5.184-1.437 4.82-5.02-.156-2.676.387-5.852-4-5.469-3.383.297-6.078 1.883-6.25 5.344-.164 3.215 2.664 4.906 5.43 5.145" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Cf)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Cg)">
                <path d="M161.465 368.93c-3.219.051-5.477.77-4.73 4.637-.715 3.758 1.906 5.617 4.621 5.594 2.809-.023 5.859-1.984 5.809-5.402-.047-3.191-2.254-4.883-5.699-4.828" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Ch)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ci)">
                <path d="M212.969 325.746c4.18 1.766 6.641-2.02 6.535-4.172-.137-2.82-3.32-5.266-6.871-5.289-3.43-.023-4.617 2.824-4.668 5.383-.055 2.668.953 5.594 5.004 4.078" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Cj)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ck)">
                <path d="M235.535 344.297c-3.086.164-5.309.473-5.074 4.52.184 3.195.484 6.012 4.266 6.355 3.715.336 5.168-1.781 4.617-5.289.133-2.855.703-5.828-3.809-5.586" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Cl)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Cm)">
                <path d="M249.301 309.844c2.453-.379 6.117-1.297 5.891-5.273-.195-3.387-3.18-4.77-5.66-4.887-2.785-.133-5.23 1.691-4.965 5.391-.293 3.352 2.293 5.148 4.734 4.77" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Cn)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Co)">
                <path d="M211.582 299.605c3.91-.105 4.938-2.195 5.18-5.703.105-1.574-.187-2.68-.773-3.449h-8.027c-.48.598-.672 1.352-.469 2.246.438 3.848-.379 7.031 4.09 6.906" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Cp)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Cq)">
                <path d="M153.238 353.883c-.414-1.906.754-5.266-3.758-5.187-3.437.059-5.191 1.539-5.387 4.992-.207 3.656 1.57 5.586 5.082 5.863 3.746.301 4.043-2.336 4.063-5.668" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Cr)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Cs)">
                <path d="M86.883 256.531c.27-2.945-3.047-5.934-5.828-5.648-2.574.262-6.246 2.523-6.008 5.973.223 3.238 2.922 5.379 5.492 5.855 5.18.098 6.133-3.883 6.344-6.18" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Ct)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Cu)">
                <path d="M21.328 209.793c-.121 3.172 1.402 6.242 5.102 6.043 3.375-.18 5.734-2.281 5.434-5.672.047-4.32-1.98-6.465-5.559-6.426-3.621.039-4.867 3.137-4.977 6.055" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Cv)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Cw)">
                <path d="M116.621 197.387c2.73-.023 6.215-.648 5.656-4.742-.352-2.578.48-6.75-4.426-5.684-4.281-.543-7.07 1.988-7.559 5.203-.574 3.777 3.117 5.25 6.328 5.223" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Cx)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Cy)">
                <path d="M68.242 243.742c.645-2.48-1.273-5.395-4.613-5.945-4.141.359-6.676 3.223-6.457 6.395.145 2.156 3.531 4.086 5.473 6.121 1.961-2.168 4.945-4.066 5.598-6.57" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Cz)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__DA)">
                <path d="M108.816 213.316c-.18-2.148-3.738-5.145-6.184-5.594-1.699-.309-5.898 1.598-4.914 5.633-.316 3.605.672 6.133 4.664 6.148 4.102.012 6.691-3.113 6.434-6.187" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__DB)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__DC)">
                <path d="M46.859 179.676c7.922-.824 11.563-1.781 11.074-5.562-.336-2.594-3.223-6.844-4.98-6.852-3.383-.016-6.551 3.309-6.777 6.918-.141 2.207 1.578 5.379.684 5.496" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__DD)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__DE)">
                <path d="M104.188 153.223c2.578.051 4.762-1.699 5.555-4.434-3.41 0-6.727.465-9.781 1.359.793 1.836 2.367 3.035 4.227 3.074" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__DF)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__DG)">
                <path d="M48.559 250.898c.137-2.766-1.172-5.156-4.875-4.973-3.207.16-5.598 1.676-5.789 5.402-.227 4.324 3.137 6.355 6.086 6.609 3.305.281 4.609-3.074 4.578-7.039" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__DH)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__DI)">
                <path d="M107.191 288.742c-1.496-.273-2.492.457-3.078 1.711h9.551c-1.395-1.043-3.664-1.508-6.473-1.711" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__DJ)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__DK)">
                <path d="M118.625 240.852c-2.66.816-4.547 4.152-6.777 6.371 2.043 1.91 3.875 5.063 6.176 5.449 3.742.629 4.723-3.441 6.535-6.262-1.895-2.305-2.406-6.648-5.934-5.559" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__DL)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__DM)">
                <path d="M18.063 235.035c.164 2.441 1.547 6.242 5.922 5.637 2.945-.406 6.168-.348 5.082-4.941 1.359-4.766-2.824-6.164-5.551-6.555-3.074-.441-5.629 3.227-5.453 5.859" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__DN)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__DO)">
                <path d="M128.293 220.566c.277-3.195-2.062-5.203-5.43-5.215-4.195-.012-6.305 2.828-6.527 6.422-.211 3.434 2.652 4.172 5.844 3.906 3.832.691 5.832-1.867 6.113-5.113" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__DP)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__DQ)">
                <path d="M96.297 250.277c4.074-.129 6.156-2.559 6.742-6.426.621-4.082-2.449-3.785-5.672-4.312-2.508.801-5.797 1.262-5.832 5.746-.027 3.316 1.449 5.102 4.762 4.992" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__DR)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__DS)">
                <path d="M77.063 184.965c4.094.262 7.293-.977 7.309-4.719.012-3.137-2.66-5.297-6.066-5.613-1.551-.145-2.77.109-3.645.789l-1.211 1.746a7.044 7.044 0 00-.391 1.996c-.207 3.402-.043 6.27 4.004 5.801" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__DT)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__DU)">
                <path d="M16.734 253.164c.043 3.711 1.477 5.063 5.176 5.148 3.938.094 6.668-2.391 6.848-5.156.148-2.316-1.973-6.098-6.156-4.539-3.809-.719-5.918.273-5.867 4.547" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__DV)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__DW)">
                <path d="M73.992 208.141c1.953.176 6.223-.937 5.473-4.672.02-3.844-.77-6.656-4.523-6.758-3.449-.094-5.961 1.547-6.402 5.348-.469 4.059 3.027 5.855 5.453 6.082" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__DX)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__DY)">
                <path d="M95.313 198.938c2.664-.105 6.18-2.496 5.754-5.918-.336-2.75-2.043-5.891-5.773-6.059-3.98-.18-4.902 2.344-4.551 6.102-.875 3.488 1.648 5.992 4.57 5.875" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__DZ)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Da)">
                <path d="M45.957 220.73c.082-2.797-1.277-4.746-4.941-4.809-3.836-.062-5.582 2.098-5.691 5.516-.102 3.098 1.488 5.84 4.758 5.863 3.441.02 5.91-2 5.875-6.57" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Db)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Dc)">
                <path d="M129.355 151.922c-.5.93-.746 2.113-.797 3.426-.145 3.746 2.477 4.426 5.695 4.441 1.07.008 2.047-.086 2.891-.324v-7.973c-1.98.359-4.625.625-7.789.43" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Dd)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__De)">
                <path d="M128.586 258.555c.023 3.34 2.516 4.406 5.551 4.355 1.121-.02 2.133-.156 3.004-.461v-9.352c-.664-.203-1.441-.285-2.336-.23-4.043-.133-6.25 1.898-6.219 5.688" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Df)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Dg)">
                <path d="M135.039 174.707c.102 1.605.895 2.805 2.102 3.547v-7.859c-1.301.996-2.215 2.449-2.102 4.313" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Dh)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Di)">
                <path d="M57.41 285.699c-1.223-1.715-2.684-2.723-4.953-2.949-4.055-.41-6.031 3.605-6.023 5.254.004.773.227 1.629.594 2.449h2.371a16.66 16.66 0 008.012-4.754" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Dj)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Dk)">
                <path d="M31.516 268.676c-2.18.383-5.43 1.523-5.676 4.57-.273 3.383 2.867 5.895 5.984 5.844 2.758-.047 6.063-1.863 6.016-5.445-.043-3.059-2.043-5.07-6.324-4.969" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Dl)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Dm)">
                <path d="M82.133 221.188c-4.711-.77-3.152 4.254-5.43 5.699 1.852 2.43 2.629 6.797 6.164 6.445 3.152-.312 4.574-3.703 4.383-7.746.992-3.836-2.152-3.922-5.117-4.398" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Dn)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Do)">
                <path d="M56.328 217.695c-.668 3.453 1.391 4.398 4.715 4.516 4.098.145 6-2.199 5.766-5.672-.191-2.836-2.051-5.074-5.621-5.023-4.066.059-5.039 2.395-4.859 6.18" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Dp)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Dq)">
                <path d="M134.988 236.348c-.215 1.789.785 3.238 2.156 4.223v-7.594c-1.184.805-1.984 1.941-2.156 3.371" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Dr)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ds)">
                <path d="M134.578 285.691c-.172 2.734.984 3.594 2.563 3.922v-10.082c-1.488 1.336-2.41 3.66-2.562 6.16" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Dt)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Du)">
                <path d="M105.406 166.398c.125-2.395-.691-5.918-4.711-5.922-3.801 0-5.359 2.996-5.391 5.703-.035 2.91 1.953 5.578 4.566 6.215 4.93.027 5.418-3.699 5.535-5.996" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Dv)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Dw)">
                <path d="M27.598 171.648c.164 3.594.77 6.09 5.078 6.117 3.953.023 5.129-3.129 5.406-5.68.332-3.047-2.027-5-7.848-5.062-.715-.035-2.82.625-2.637 4.625" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Dx)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Dy)">
                <path d="M85.355 160.945l-2.562 3.27c1.77-.289 2.344-1.488 2.563-3.27" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Dz)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__EA)">
                <path d="M130.371 206.434c.043 3.281 3.035 4.941 5.68 4.961.379.004.746-.031 1.09-.098v-11.219c-2.812 1.043-6.824 2.172-6.77 6.355" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__EB)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__EC)">
                <path d="M57.961 199.441c.008-2.812-1.926-5.508-5.699-4.527-3.195-.414-6.234.152-6.277 3.77-.039 3.195 2.086 5.188 5.777 5.086 3.195-.086 6.195-1.09 6.199-4.328" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__ED)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__EE)">
                <path d="M100.063 273.227c4.23.168 4.926-3.641 5.234-5.812.281-1.977-1.699-5.086-5.152-4.855-3.371.227-4.844 2.301-5.191 5.145.082 3.691 1.559 5.383 5.109 5.523" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__EF)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__EG)">
                <path d="M60.031 159.75c.113.008.211-.004.32 0l-3.805-1.387c.504 1.426 1.672 1.797 3.484 1.387" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__EH)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__EI)">
                <path d="M119.367 176.648c4.434 1.57 6.035-2.602 6.145-4.984.102-2.211-2.445-4.953-6.066-5.051-4.582-.125-4.043 2.988-4.266 5.828-.227 2.93.367 5.004 4.188 4.207" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__EJ)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__EK)">
                <path d="M33.875 184.301c-3.812.035-4.859 2.426-4.762 5.754.074 2.563.082 5.004 3.805 4.867 3.801-.141 5.355-2.004 5.035-6.133.766-2.93-.734-4.52-4.078-4.488" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__EL)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__EM)">
                <path d="M57.207 273.125c3.352-.238 5.211-2.254 5.395-5.652.18-3.355-1.609-4.855-7.203-5.129-1.973-.191-1.715 2.871-1.633 5.676.074 2.379-.391 5.379 3.441 5.105" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__EN)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__EO)">
                <path d="M124.23 277.598c.098-3.453-1.242-4.469-4.582-4.582-4.098-.141-4.406 2.203-4.324 5.172-.117 2.551-.422 4.957 3.535 4.773 3.703-.172 5.262-1.633 5.371-5.363" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__EP)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__EQ)">
                <path d="M136.488 333.16l.656.66v-1.453a4.114 4.114 0 01-.656.793" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__ER)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__ES)">
                <path d="M103.832 363.598c3.613.109 5.957-2.418 5.941-5.437-.02-2.914-2.094-5.562-5.957-5.035-3.566-.215-6.234.656-6.105 5.004.121 4 2.68 5.367 6.121 5.469" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__ET)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__EU)">
                <path d="M94.172 344.902c3.074-.094 6.09-1.309 5.57-4.137-.215-4.977-1.687-7.668-5.426-7.746a5.61 5.61 0 00-1.207.102c.07 3.781-.031 7.711-.262 11.68.418.078.855.117 1.324.102" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__EV)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__EW)">
                <path d="M137.141 315.98v-8.039c-1.437.797-2.293 2.168-2.238 3.938.059 1.816.965 3.152 2.238 4.102" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__EX)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__EY)">
                <path d="M115.137 293.934c.137-1.605-.43-2.699-1.473-3.48h-9.551c-.469 1.008-.672 2.348-.605 3.816.137 2.93 1.363 5.434 5.105 5.301 3.754-.133 6.262-2.535 6.523-5.637" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__EZ)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ea)">
                <path d="M135.906 377.625c.438.07.844.055 1.234.008v-11.125c-.633-.336-1.273-.52-1.836-.547-2.16-.117-6.211 3.402-6.406 5.59-.32 3.543 3.781 5.547 7.008 6.074" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Eb)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ec)">
                <path d="M123.121 396.125c-2.609-.031-4.727 1.199-5.793 2.926h10.543c-.719-1.715-2.262-2.898-4.75-2.926" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Ed)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ee)">
                <path d="M115.82 326.918c-.035 3.609 2.219 5.379 6.133 5.25 3.297-.105 5.805-.91 5.621-4.574-.16-3.227-1.5-5.91-5.398-5.23-3.617-.277-6.32.984-6.355 4.555" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Ef)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Eg)">
                <path d="M47.031 290.453c.063.148.148.289.223.434.727-.109 1.441-.25 2.145-.434" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Eh)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ei)">
                <path d="M104.063 396.004c.125-3.617-1.809-5.605-4.539-5.73-3.57-.168-5.062 2.52-4.363 6.16-.262.98-.273 1.855-.105 2.617h8.473c.313-.891.5-1.914.535-3.047" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Ej)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Ek)">
                <path d="M118.922 385.781c3.473-.047 5.27-1.391 5.25-4.996-.023-3.695-2.059-4.945-5.195-4.816-3.641-.09-5.633 1.414-5.555 4.98.082 3.523 2.035 4.879 5.5 4.832" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__El)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Em)">
                <path d="M128.555 349.293c.133-2.715.547-5.328-3.738-5.047-3.371.219-5.426.699-5.223 4.863.18 3.625 1.402 5.652 5.082 5.832 4.309.211 3.75-2.992 3.879-5.648" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__En)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Eo)">
                <path d="M107.484 314.883c-.113-3.316-1.711-4.84-5.309-5.113-2.992.297-4.242 2.051-4.586 5.496-.371 3.695 1.445 5.262 4.336 5.113 2.961-.152 5.699-1.5 5.559-5.496" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Ep)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Eq)">
                <path d="M97.82 378.48c-.164-3.031-.32-5.488-4.437-5.18-1.578.121-2.98.352-4.059.973l-1.277 7.109c1.043.91 2.766.82 4.109 1.016 3.176-.004 5.891.223 5.664-3.918" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Er)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Es)">
                <path d="M132.082 302.922c.105-3.203-1.187-5.16-4.535-5.281-3.434-.125-5.227 1.434-5.25 5.059-.023 2.953.121 5.453 3.809 4.766 3.613.238 5.855-.77 5.977-4.543" />
            </g>
        </g>
        <g
            clipPath="url(#tickets-illustration_svg__Et)"
            className="tickets-illustration_svg__B"
        >
            <g clipPath="url(#tickets-illustration_svg__Eu)">
                <path d="M95.191 298.086c-.195-3.488-2.645-5.965-5.051-6.125-.961-.062-2.305.27-3.375 1.133.164 2.992.484 6.086.996 9.242a2.16 2.16 0 00.477.008c4.609-.262 7.18-.262 6.953-4.258" />
            </g>
        </g>
        <path
            d="M147.043 90.828s-8.078-9.484-5.965-33.332c2.555-28.855 27.215-34.332 27.215-34.332s-2.227-15.059 13.598-20.27c15.82-5.203 23.668-2.613 32.82 1.637s11.223-.684 20.305 6.211c12.055 9.152 44.746 15.363 42.457 26.152-2.535 11.945-29.094 0-31.707 3.266-4.785 5.977 18.824 16.883 13.398 23.211-3.922 4.578-16.094-.922-12.746 4.578 4.574 7.516-.98 29.746-13.73-6.539l-69.691 37.738"
            fill="#FB85BB"
        />
        <path
            d="M66.629 169.938s11.113-44.457 15.363-57.207l4.25-12.75s6.211-6.863 3.598-25.824c0 0 3.594-2.613 4.574-11.113 0 0 4.902-9.48 0-10.457 0 0 2.289-6.215-4.25-6.867 0 0-1.305-8.824-6.211-8.824s-2.344 9.152-2.344 9.152-18.578-.328-22.824 5.23 3.27 33.668-1.309 52.137-22.23 53.445-22.23 53.445 5.887 17 31.383 13.078m118.332 39.878s-9.152-8.5-12.746-17.98-3.598-14.383-13.402-25.168.324-11.113 0-29.422-4.289-24.516-4.289-24.516-5.844 5.559-9.113-3.27-7.848-24.187 0-25.168c3.184-.398 5.426 5.023 8.223 6.535 4.09 2.211 7.047-5.937 3.359-15.34-7.684-19.59-.469-32.383 10.316-38.594 0 0 5.887 3.922 17.652 1.305s17.652 1.961 23.863 9.809 19.613 8.5 23.863 13.402c0 0-4.25 6.863-1.633 15.363s5.555 25.496 2.941 36.285-9.48 25.496-9.48 25.496-.328 22.227 2.289 30.398c0 0 1.305 14.711-11.77 19.613s-29.094 8.828-30.074 21.25"
            className="tickets-illustration_svg__E"
        />
        <path
            d="M312.449 237.602l2.941-12.746 7.492-35.629 5.711-11.484s-6.484-4.516-4.914-8.445 9.363 0 9.363 0l3.211-9.035-26.91-9.82-2.945 7.66-9.035-.98v12.566s5.895 1.375 5.305 4.32-6.484 3.145-6.484 3.145l-2.09 13.469-12.832 29.938 8.301 2.953-.977 6.246"
            fill="#EF5437"
        />
        <path
            d="M318.66 189.551s-1.637-6.211-9.152-5.887-14.711 0-16.02 5.887 0 10.133 0 10.133-5.738 8.5-.582 14.055c0 0-.07 4.25 5.813 8.828 0 0-1.961 8.496 10.461 7.844 0 0 4.25-3.27.98-4.902l5.23-.656-2.941 12.75-23.863-7.844s5.23 16.344 9.805 23.859 5.23 48.707 5.23 48.707 19.941 5.887 29.422-8.824c0 0-4.25-33.016-3.598-40.863s-1.961-8.172-.652-14.707 4.574-16.344-.328-23.863c0 0 6.211-9.809.652-14.383 0 0 1.871-8.488-3.594-10.133-2.41-.727-6.863 0-6.863 0"
            className="tickets-illustration_svg__E"
        />
        <g className="tickets-illustration_svg__C">
            <path d="M186.5 117.906c-.437.359-.437 1.082.094 2.027.926 1.609 2.484 2.25 4.328 2.426 1.012.105 2.051-.113 2.934-.41 1.133-.383 2.117-1.004 3.219-1.32.176-.055.422-.246.625-.375l3.125-2.09c.707-.41 1.41-.633 2.109-.82.465-.129.957-.141 1.344-.418.109-.082.395-.074.598-.074.313.004.625.027.906.094.27.051.512.137.742.227.105.063.223.102.316.176l.141.098c.066.043.043.051.195.168.508.488 1.078.816 1.676.863a2.22 2.22 0 001.566-.434 4.24 4.24 0 00.633-.273l.492-.262c.164-.066.207-.047.313-.082.18-.047.383-.113.672-.234a.772.772 0 01.48.004l.82.27a6.42 6.42 0 01.902.402c1.086.637 1.914.703 2.793.844.07.012.133-.012.16-.055.25-.418.832-.594.168-1.707-.203-.328-.258-.621-.719-.941-.148-.105-.371-.312-.441-.426-.34-.594-1.086-1.031-1.91-1.395-.801-.352-1.645-.641-2.625-.664-.422-.016-.988.039-1.332.203a6.977 6.977 0 00-1.246.742c-.199.148-.164.137-.184.156a.104.104 0 01-.047.035.078.078 0 01-.102-.031c-.047-.059.012-.059-.07-.164-.391-.32-.891-.566-1.375-.746-1.68-.609-3.355-.523-4.852-.215-.742.156-1.531.277-2.191.598l-3.016 1.535c-.187.086-.383.246-.566.379l-1.758 1.242a10.02 10.02 0 01-1.18.668c-.309.148-.645.27-.98.371-.312.086-.621.117-.918.164a7.25 7.25 0 01-2.582-.078l-1.668-.457c-.91-.266-1.379-.207-1.59-.02" />
            <path d="M195.926 118.77c.176.555.621.887 1.215 1.164.492.215.871.328 1.223.348l1.07-.027c.41-.016.852-.109 1.281-.191.539-.129 1.109-.293 1.672-.043.094.043.254.008.383.004l2.195-.008c.523.035 1.043.168 1.574.227.352.043.719.16 1.059-.051.09-.059.309-.016.469-.004l.758.082 1.41.152c.445.094.855.113 1.199-.102.621.219 1.242.313 1.863.047a1.22 1.22 0 01.508-.094c.586.031 1.129-.152 1.668-.34.957-.312 1.191-1.039 1.48-1.629a.17.17 0 000-.156c-.191-.445-.215-.977-.937-1.129-.211-.047-.359-.18-.613-.062-.086.031-.238.035-.301-.008-.34-.223-.695-.082-1.07-.102s-.727-.094-1.094-.145c-.164-.027-.367-.07-.496-.016-.684.293-1.395.176-2.105.012-.207-.051-.434-.047-.652-.051l-2.289-.07c-.387-.023-.773-.176-1.156-.156-.637.027-1.242-.012-1.859-.207-.117-.035-.273-.016-.41-.012l-1.414.07-.992.066-.801.031-.75-.016c-1.934.094-3.07.637-3.605 1.18-.543.531-.559.984-.48 1.234m-3.359 2.033c-.465.348-.391 1.109.164 2.219.977 1.863 2.301 2.719 3.992 3.676.918.52 2 .883 3.039 1.129l3.988.785c.219.074.598.051.902.055 1.711.043 3.41-.152 5.066-.473l1.762-.359c.316-.078.641-.16 1.031-.316.379-.164.871-.367 1.406-.984a2.85 2.85 0 00.637-1.582 2.9 2.9 0 00-.027-.703 2.65 2.65 0 00-.316-.93 2.51 2.51 0 00-1.457-1.145 2.39 2.39 0 00-1.012-.086l-1.305.074-.906.145-.715.125a12.56 12.56 0 01-2.535.203c-.812-.047-1.523-.086-2.156.105-1.125-.277-2.129-.547-3.273-.527a3.535 3.535 0 01-.867-.156l-2.738-.832a9.457 9.457 0 00-1.805-.504c-.242-.051-.488-.074-.723-.113l-.699-.164c-.078-.023-.145-.008-.176.031-.133.203-.359.332-.437.582-.07.23-.035.691.547 1.344.328.406.512.691 1.133 1.02.207.09.52.281.629.398.551.574 1.469.883 2.301 1.203l2.484.867c.367.094.836.242 1.152.227 1.652-.02 3.223.164 4.898.234a10.03 10.03 0 001.508-.105l1.293-.211 1.164-.254c.309-.062.617-.105.832-.105a.68.68 0 01.129 0l.035.004c.008-.027.004.074.035-.121.141-.578.371-.914.453-.961l.008-.008a.218.218 0 01-.047.016l-1.043.223a1.66 1.66 0 01.348-.059c.109-.012.168-.023.262-.016.297 0 .316.098.133-.047a.994.994 0 01-.16-.152 2.28 2.28 0 01-.211-.25c-.02-.043-.082-.113-.121-.172l-.066-.094c-.016-.027 0-.008-.004-.016.004-.004-.016.004-.023.008l-.266.113c-.414.195-1.039.34-1.578.445a8.019 8.019 0 01-1.672.133c-.219-.012-.488.043-.73.074a18.06 18.06 0 01-2.484.113l-1.707-.172c-.457-.055-.906-.18-1.352-.293-.406-.117-.785-.301-1.184-.434a28.783 28.783 0 01-3.547-1.699l-2.145-1.148c-1.086-.539-1.633-.527-1.844-.359m36.586-51.978c.301-.492-.684-1.379-2.785-2.395-1.785-.832-3.5-1.289-5.305-1.383-1.789-.082-3.738.16-5.734 1.191a9.22 9.22 0 00-1.508.992l-.68.594-.656.73c-.777.977-1.312 1.977-1.754 2.98-1.125 2.598-1.52 5.25-1.852 8.016-.039.449 0 1.219.07 1.836.176 1.789.547 3.336.941 4.938.418 1.59.918 3.18 1.563 4.742a25.8 25.8 0 003.551 6.195c.941 1.207 1.629 2.27 1.992 2.93.059.09.082.238.082.344-.004.113-.031.145-.066.195-.02.066-.25.25-.367.289-.109.031-.094.043-.281-.008-.039-.02-.078-.031-.121-.047-.055-.035-.051-.016-.273-.145l-1.004-.633c-.332-.16-.664-.309-.949-.305l-.879.031c-.395.242-.68.402-.992.691-.281.336-.5.813-.703 1.305l-.305.668a1.36 1.36 0 01-.141.223 2.01 2.01 0 01-.309.359c-.367.336-.789.555-1.32.723-.238.082-.57.168-.777.211-.215.063-.422.082-.637.129-.656-.191-1.273-.574-1.922-1.145l-1.008-.941-.699-.676a5.116 5.116 0 00-1.211-.906l-.34-.105-.086-.023c-.047.086-.062.016-.098.031l-.18-.031c-.234-.059-.48-.02-.715-.008a5.05 5.05 0 00-1.551.672l-.387.234-.23.152-.41.258c-.91.57-1.672.969-2.324 1.137-.633.145-1.156.07-1.781-.27-.512-.305-.645-.508-.762-.77-.113-.27-.105-.652-.008-1.012s.262-.711.488-1c.227-.297.512-.57.895-.723.121-.055.184-.125.152-.168-.152-.223-.066-.484-.41-.684-.176-.094-.473-.148-.961-.055s-1.152.379-1.852 1.121c-.379.465-.699.867-.887 1.445-.187.551-.336 1.316.035 2.258.227.602.836 1.438 1.105 1.668a4.64 4.64 0 002.707 1.512c1.176.215 2.391-.051 3.332-.434.949-.375 1.742-.855 2.445-1.262.441-.266.434-.234.469-.23s.059.023.07.059c.004.016.008.027.008.039l.008.027.117.125a7.53 7.53 0 00.809.785c.676.547 1.414 1.102 2.285 1.551.863.449 1.887.781 2.953.828.266.027.531.012.793-.008.27-.02.531-.043.754-.094.465-.07.941-.203 1.422-.359.953-.34 1.949-.945 2.672-1.797.211-.238.402-.496.566-.77.09-.133.156-.27.23-.406-.016.027 0 .004 0 .004l.02-.07.008-.008c.02-.004.035.008.055.012.07.02-.195-.059.621.254.602.203 1.367.301 2.109.152.758-.145 1.344-.516 1.844-.895a4.18 4.18 0 001.238-1.652c.285-.687.34-1.422.27-2.039-.16-1.242-.645-2.137-1.133-2.934l-1.496-2.121-1.301-1.816c-1.398-1.934-2.25-4.09-2.754-6.395-.082-.453-.277-1-.402-1.512l-.605-2.617c-.148-.816-.27-1.645-.289-2.48a14.92 14.92 0 01.254-3.457c.184-.914.438-1.824.785-2.684.316-.793.734-1.523 1.176-2.199.207-.324.43-.617.641-.863.105-.141.207-.211.305-.32l.379-.332a6.59 6.59 0 011.539-.957c1.043-.461 2.129-.641 3.141-.703 2.031-.121 3.684.141 4.895.242l2.566.195c.527-.016.77-.117.84-.23m-42.113-1.367c.195-.551 0-1.078-.535-1.656-.922-.957-1.805-1.027-2.883-1.16-.59-.066-1.223.004-1.809.109-.762.141-1.453.414-2.254.313-.133-.023-.328.07-.492.117-.926.262-1.816.621-2.691 1.008l-1.867.828c-.395.211-.844.406-1.043.832-.055.117-.285.258-.445.379l-.75.574-1.301 1.141c-.422.352-.758.715-.836 1.176-.621.461-1.141.992-1.305 1.77a1.618 1.618 0 01-.254.531c-.371.57-.547 1.195-.691 1.816-.262 1.113.215 1.711.586 2.32a.18.18 0 00.133.086c.48.047.953.313 1.457-.32.156-.18.359-.254.402-.562a.49.49 0 01.168-.285c.355-.211.473-.613.691-.957.215-.336.504-.613.762-.914.117-.125.27-.277.305-.422.188-.754.727-1.289 1.332-1.73.18-.117.324-.305.48-.457.531-.543 1.102-1.059 1.73-1.48.316-.211.707-.312 1.004-.516.504-.363 1.055-.598 1.66-.645.117-.008.242-.086.363-.141l1.242-.457.898-.219c.242-.047.488-.086.734-.094.227-.016.457.016.684.02 1.73.031 2.762-.008 3.449-.211.68-.191.992-.547 1.074-.793" />
        </g>
        <path
            d="M158.887 182.039c.262.141.57.055.914-.32.332-.371.652-1.055.758-2.02.152-1.637-.414-3.121-1.398-4.262a6.13 6.13 0 00-1.836-1.43c-.68-.344-1.332-.555-1.941-.762l-1.695-.582c-.449-.191-.598-.312-.684-.43-.078-.055-.168-.312-.254-.875l-.215-1.027a4.294 4.294 0 00-.629-1.328c-.758-1.066-2.168-1.586-3.465-1.527-.488.004-1.242.254-1.801.578-1.613.977-2.203 2.246-2.793 3.137a10.38 10.38 0 01-.809 1.168 8.227 8.227 0 01-.953.969c-.984.832-2.207 1.375-3.453 1.691-.824.219-1.703.234-2.469.457-.211.07-.734.008-1.105-.055-.309-.051-.57-.094-.805-.184a4.245 4.245 0 01-.707-.301c-.398-.219-.723-.5-.863-.719-.125-.23-.113-.293-.051-.488.066-.207.328-.707.559-1.238a7.75 7.75 0 00.488-1.48c.906-1.5 1.703-2.926 2.195-4.605.109-.363.324-.867.523-1.258.715-1.402 1.223-2.789 1.754-4.168.945-2.461.824-3.625.879-5 .004-.109-.031-.176-.086-.176-.52-.008-.816-.625-1.984 1.172-.344.527-.66.809-.973 1.629-.098.266-.312.68-.437.832-.633.75-1.09 1.891-1.617 2.934l-1.637 3.027-.668 1.391a25.08 25.08 0 01-1.195 3.004l-.715 1.449c-.23.469-.594 1.066-.777 1.988-.234 1.082.168 2.457.84 3.254.555.723 1.211 1.195 1.871 1.563a7.63 7.63 0 002.063.773 11.94 11.94 0 003.984.164c1.297-.156 2.648-.414 3.781-.977 1.914-.969 3.539-2.219 4.918-3.82.277-.305.512-.738.711-1.066l.902-1.355c.309-.352.426-.441.699-.535a1.51 1.51 0 01.203-.051c.02-.008.035-.008.055-.008.035-.004.07.016.098.039l.012.016c.02.047.02-.027.074.324l.168 1.199a4.5 4.5 0 001.707 2.77c.809.586 1.543.848 2.16 1.059l1.594.477c.93.277 1.324.465 1.762.809.844.684 1.27 1.539 1.531 2.164.465 1.289.535 1.898.813 2.012m82.635 3.807c-.352-.473-1.227-.258-2.523.418-2.191 1.156-3.367 2.461-4.961 4.086-.859.879-1.68 1.906-2.437 2.891-.977 1.273-1.82 2.59-3.016 3.68-.195.176-.434.555-.645.84l-3.527 4.48a9.75 9.75 0 01-2.879 2.039c-.664.309-1.406.438-2.008.766-.168.086-.613.105-.918.094a4.31 4.31 0 01-1.371-.246c-.77-.285-1.371-.746-1.988-1.605-.578-.801-1.207-1.715-2.09-2.293-.566-.738-1.387-1.441-2.266-1.867a6.01 6.01 0 00-2.793-.629l-1.465-.016c-1.687-.02-3.168.52-4.461 1.129-2.301 1.145-2.73 2.176-3.492 3.164-.059.078-.066.152-.023.188.391.332.316.957 2.102.352.523-.172.895-.176 1.535-.543.207-.117.574-.254.738-.266.813-.059 1.719-.418 2.586-.516s1.699.012 2.453.215l.965.297c.699.137 1.242.453 1.777 1.043.543.586 1.031 1.387 1.695 2.273.379.504.93 1.047 1.563 1.508 1.109.801 2.445 1.25 3.723 1.355 1.281.121 2.52-.062 3.68-.402 1.137-.336 2.344-.801 3.242-1.488 1.52-1.152 2.676-2.406 3.859-3.57.23-.227.461-.562.672-.848l2.059-2.855 1.445-1.898 1.223-1.488 1.191-1.297 5.605-6.801c.875-1.355.91-1.977.75-2.187"
            className="tickets-illustration_svg__F"
        />
        <g className="tickets-illustration_svg__C">
            <path d="M224.277 138.734c-.312-.496-1.344-.219-2.812.758-2.477 1.641-3.645 3.328-5.488 4.867-.98.82-2.039 1.578-3.184 2.188-1.453.781-3.07 1.398-4.84 1.418-.285.012-.762.117-1.148.172-2.195.301-4.48.395-6.801.371l-4.816-.281-2.883-.375c-.246.004-.789-.211-1.168-.371a10.228 10.228 0 01-1.758-.965 17.033 17.033 0 01-2.98-2.527c-.875-.937-1.672-1.805-2.547-2.379-1.152-1.465-2.27-2.797-3.738-3.937a9.636 9.636 0 01-1.047-1.004c-1.125-1.242-2.301-2.281-3.469-3.344-2.078-1.887-3.25-2.242-4.57-2.844-.102-.047-.184-.039-.203.012-.184.492-.883.527.469 2.363.395.539.563.949 1.258 1.574.223.203.559.574.66.754.52.906 1.469 1.797 2.309 2.719l2.395 2.773 1.129 1.195c1.813 1.461 3.258 3.141 4.914 4.934.48.508 1.07 1.02 1.66 1.492 1.016.813 2.137 1.566 3.387 2.156 1.246.605 2.598.98 3.898 1.215 1.293.234 2.609.445 3.801.449l5.762.152c.375.02.844-.012 1.27-.043l4.363-.488 3.027-.684a23.97 23.97 0 002.41-.816l2.156-.984c1.34-.75 2.445-1.637 3.301-2.477s1.516-1.637 2.066-2.34l2.266-3.266c.973-1.578 1.105-2.207.953-2.437m16.838-99.636c.531-.25.535-1.113.16-2.484-.664-2.316-1.809-3.789-3.684-5.426-1.023-.867-2.348-1.562-3.727-1.941a10.45 10.45 0 00-2.746-.348c-.937.008-1.832.117-2.68.18-.277.02-.715.18-1.051.285-1.887.586-3.578 1.277-4.805 1.137-.867-.098-1.367-.516-2.051-1.379-.441-.551-.867-1.375-1.594-1.945-.199-.152-.551-.66-.848-.98a17.395 17.395 0 00-1.465-1.484c-.953-.855-2.035-1.574-3.07-2.227-1.008-.641-1.984-1.074-2.895-1.164-1.453-.734-2.953-1.215-4.566-1.184-.352.012-.852-.035-1.25-.082-1.426-.191-2.77-.066-4.086.094-2.348.32-3.133 1.09-4.121 1.773-.078.055-.109.121-.082.168.254.449-.004.996 1.777 1.055.523.027.855.152 1.563.031.23-.043.613-.047.77-.008.785.211 1.766.125 2.699.203s1.805.27 2.684.477l1.176.25c1.688.098 3.27.773 4.645 1.707l1.25.809a13.29 13.29 0 011.949 1.602c.609.598 1.082 1.207 1.648 2.016.563.777 1.141 1.82 2.172 2.582.863.656 1.934 1.074 2.953 1.246 1.027.176 1.996.125 2.875.047.336-.039.754-.156 1.094-.262l3.172-1.039c.664-.191 1.289-.32 1.863-.348.457-.02.934.031 1.398.152.43.113.836.305 1.25.508 1.594.789 2.688 1.844 3.582 2.73l2.113 2.148c1.098 1.051 1.691 1.215 1.926 1.102m80.487 149.264c.297-.059.449-.348.641-.711l.777-1.496c.289-.574.574-1.207.695-2.008.125-.789-.035-1.875-.605-2.691-.551-.824-1.277-1.305-1.906-1.652s-1.234-.582-1.754-.824c-.43-.195-.812-.383-.965-.5-.023-.008-.027.008-.055-.004-.016-.004-.027-.016-.035-.035-.004-.012-.008-.023-.008-.043a.887.887 0 01.145-.187 1.47 1.47 0 01.527-.328c.473-.164 1.223-.16 2.141-.035.152.02.363.016.598-.004.293-.02.805-.078 1.148-.148 1.031-.176 1.922-.852 2.273-1.809.188-.465.242-1 .254-1.535l.027-.941.051-3.359.063-4.75-.039-1.582c-.039-.512-.066-1.023-.305-1.707l-.211-.676a4.162 4.162 0 00-.508-.992 3.58 3.58 0 00-.375-.445c-1.094-1.012-2.141-1.141-2.906-1.324l-3.965-.742c-1.242-.27-2.352-.449-3.332-.367-1.703-.437-3.316-.777-5.074-.73-.383.012-.93-.039-1.367-.102-1.566-.238-3.047-.27-4.535-.309-2.648-.066-3.703.465-5 .898-.102.031-.152.09-.137.141.176.492-.285.98 1.785 1.445.609.141.98.336 1.848.352.281.004.742.063.922.129.914.344 2.125.398 3.27.563l3.352.602c.492.09 1.105.211 1.516.211 2.145.008 4.227.395 6.332.871l1.914.328 2.074.336c.285.055.512.117.645.172l.141.074c.008.016.02.027.027.043.02.047.043.137.063.254.039.23.059.629.078 1.027l.043 3.289c.105 1.793.09 3.496-.125 5.199-.043.332-.027.754-.035 1.133l-.008.48c-.004.113 0 .078.004.086l.004.008c.012.008.02.023.02.043s-.008.031-.02.047l-.023.016-.016.004-.172.016c-.781.066-1.793.012-2.988.266-1.035.23-2.043.738-2.84 1.613-.711.773-1.156 1.875-1.035 2.961l.121.543c.137.602.465 1.125.855 1.563.195.199.445.438.625.559l.543.352c.691.391 1.262.59 1.73.777l1.148.469c.27.141.461.258.551.336.082.086.16.125.207.238a1.54 1.54 0 01.121.516c.043.438.012.965.016 1.438-.016.957.18 1.762.438 2.164.254.418.496.5.613.48" />
            <path d="M310.629 175.172a4.58 4.58 0 00-.207-1.477c-.23-.75-.402-.707-.621-.801-.121-.051-.246.008-.367.066-.16.074-.312.254-.465-.016-.027-.043-.07 0-.105.008-.195.031-.391.094-.586.094-.137 0-.273-.098-.414-.117-.09-.016-.184-.109-.266.129-.023.063-.082.035-.121.031-.066 0-.129-.016-.195-.023-.117-.023-.238-.008-.352-.078s-.211-.09-.293.133c-.156-.195-.301-.324-.453-.07-.031.055-.082.07-.121.055-.137-.062-.266.055-.398.152-.23.172-.32.77-.434 1.293a.93.93 0 00-.012.152c.02.477-.02 1 .168 1.313.055.09.09.262.168.199.023-.02.066 0 .082.051.086.258.191.199.297.242s.199.152.301.219c.047.031.102.074.137.023.191-.27.379-.18.574-.039.051.039.113.023.172.016l.598-.082c.098-.004.203.117.297.074a.37.37 0 01.469.09c.031.035.07.004.105-.008l.344-.109.242-.051a.63.63 0 01.191-.004c.059.012.117.055.176.066.91.188 1.082-1.016 1.09-1.531m-14.103 58.262c.09-.582-.277-1.055-.906-1.578-1.047-.887-1.844-.996-2.883-1.34-.547-.187-1.168-.301-1.73-.422-.691-.141-1.398-.258-1.652-.777-.039-.078-.16-.125-.23-.184-.375-.32-.555-.594-.543-1.316.02-.492.242-1.062.438-1.703.133-.426.363-.91.25-1.383-.031-.133.074-.406.133-.609l.293-.965.57-1.766c.227-.543.379-1.035.285-1.52.402-.727.727-1.418.695-2.258a1.78 1.78 0 01.117-.621c.254-.684.32-1.371.41-2.055.16-1.223-.293-1.832-.641-2.535-.027-.055-.082-.094-.129-.098-.488-.031-.941-.367-1.5.496-.164.254-.375.383-.426.785-.016.133-.094.336-.164.406-.367.355-.461.918-.645 1.43-.184.504-.43.977-.637 1.473-.09.215-.211.484-.215.68-.008 1.035-.355 1.961-.758 2.895-.117.27-.187.578-.262.871l-.754 3.039c-.133.488-.406 1-.488 1.57-.129.965-.301 1.977-.223 3.242.02.246.133.547.246.813.379.914 1.063 1.688 1.758 2.18.48.355.969.613 1.441.824l1.113.457.945.371c2.418.801 3.988.73 4.879.508.902-.238 1.172-.656 1.211-.91m30.713-19.137c.457-.355.148-1.332-.895-2.773-.895-1.215-1.953-2.121-3.23-2.77a8.54 8.54 0 00-4.523-.848c-1.844.148-3.539.98-4.879 1.879-1.758 1.172-3.035 2.602-4.613 3.488-.254.141-.609.473-.918.699-.875.645-1.684 1.148-2.652 1.559l-3.262 1.242c-1.66.652-3.551 1.531-4.922 3.328-.441.578-.84 1.293-1.055 2.063s-.25 1.57-.074 2.238c.082.359.188 1.258.438 1.879.359.969.91 1.84 1.598 2.57 1.309 1.359 2.949 2.105 4.555 2.555 1.555.434 2.949.441 4.043.156l1.496-.016 1.488-.168c.563-.121 1.258-.281 2.02-.895.785-.602 1.309-1.797 1.125-2.84-.027-.105-.039-.109-.051-.113l-.035-.043a.43.43 0 01-.051-.066c-.031-.016-.012-.094.039-.082a.268.268 0 00.113-.039l.074-.035.047-.023.289-.07a10.38 10.38 0 001.246-.383c1.516-.566 2.391-1.324 2.969-2.004.578-.695.875-1.348 1.152-2.035.047-.109.035-.187-.016-.203-.258-.078-.402-.285-.695-.312s-.711.148-1.594.613c-.535.262-.91.313-1.609.707a2.51 2.51 0 01-.816.273c-.34.012-.687.059-1.055.109l-.277.035-.156.02-.309.023c-.402.043-.832.07-1.293.051l-.465.016-.352.109c-.223.074-.504.133-.613.23l-.414.258a1.59 1.59 0 00-.387.496c-.199.461-.148.473-.203.813a2.23 2.23 0 00.379 1.473c.098.137.266.344.348.402l.078.066.02.016.012.012v.004c.219-.02-.484.039.488-.043h.012l.055-.004c.043.004.004.008-.086-.031l-.078-.031-.02-.012-.008-.004c-.117-.062.156.078.129.066v-.004c.012.008-.02-.008-.031-.023a1.432 1.432 0 01-.289-.332l-.051-.074-.012.004-.035.02-.133.07c-.242.152-.844.285-1.352.383a10.09 10.09 0 01-1.547.176c-1.016.043-2.008-.078-2.883-.375-.5-.164-1.023-.348-1.484-.598-.824-.43-1.418-.977-1.816-1.687-.387-.68-.504-1.508-.348-2.172.16-.68.766-1.273 1.422-1.84 1.125-1 2.73-1.492 4.602-1.988.367-.102.816-.301 1.23-.488 1.453-.625 2.801-1.559 3.934-2.473l2.246-1.871 1.73-1.316a13.719 13.719 0 011.637-.891c2.121-.984 3.602-.863 4.938-.43 1.324.43 2.363 1.059 3.156 1.473 1.59.883 2.273 1.008 2.48.832m1.327-13.665c.441-.379.297-1.168-.379-2.324-.582-.973-1.305-1.715-2.223-2.277a6.76 6.76 0 00-3.418-.98c-1.535-.039-2.812.57-3.75.977-1.25.551-2.434 1.191-3.805 1.422-.223.035-.559.211-.844.324l-4.77 1.898-3.43 1.168c-.746.266-1.57.477-2.168.953-.16.129-.629.277-.965.402l-1.609.586-3.051 1.305c-.988.445-1.844 1.008-2.359 1.723-1.348.859-2.477 2.043-2.953 3.676l-.41 1.258c-.496 1.469-.312 3.125.246 4.426.496 1.172 1.121 1.746 1.656 2.141.551.383 1.055.57 1.578.781.082.035.152.023.18-.02.281-.434.809-.531.172-1.922-.168-.414-.168-.715-.48-1.191-.098-.152-.199-.437-.187-.562.035-.637-.148-1.25-.039-1.902.094-.637.406-1.227.781-1.789.156-.254.406-.539.508-.77.563-1.23 1.781-2.051 3.176-2.629l1.262-.59 4.746-1.934 2.457-.852c1.301-.57 2.559-1.039 3.883-1.363.258-.062.563-.211.836-.324l2.809-1.176 1.945-.789 1.582-.602 1.434-.461c.863-.277 1.395-.371 1.879-.34.5.023.98.137 1.438.305.914.34 1.68.773 2.281 1.047 1.211.582 1.797.586 1.992.406M323.598 189.973c.246-.148.434-.383.367-.77-.051-.379-.437-.863-1.012-1.172-.969-.527-1.832-.523-2.418-.543-.648-.008-1.277.086-1.992.156-.766.078-1.566.289-2.32.496-.965.273-1.879.656-2.91.625-.168-.008-.426.098-.641.156l-3.602 1.02-2.562.594c-.555.145-1.172.23-1.609.605-.117.102-.465.172-.711.246l-1.176.328-2.184.59c-.715.156-1.355.359-1.809.781-1.039.195-2.055.531-2.867 1.344a4.47 4.47 0 01-.703.547c-.859.57-1.5 1.344-2.02 2.191-.914 1.551-.516 2.516-.207 3.332.027.066.082.105.133.105.508.016.918.266 1.539-.52.203-.227.418-.301.57-.66a.718.718 0 01.273-.324c.457-.191.773-.629 1.203-.961.43-.324.914-.527 1.41-.746.219-.098.5-.199.656-.332.813-.715 1.898-1.023 3.047-1.242.332-.062.684-.187 1.023-.301l3.559-1.152 1.797-.437c.949-.352 1.875-.594 2.84-.684.191-.016.41-.102.613-.164l2.059-.621 1.434-.379 1.164-.254 1.078-.145 3.328-.652.605-.168.422-.145.563-.215c.266-.125.398-.258.59-.332.184-.086.359-.125.469-.199" />
        </g>
        <g className="tickets-illustration_svg__F">
            <path d="M291.188 363.473c.598.055.949-.953 1.406-2.641.809-2.836 1.031-4.855 1.637-7.555l.934-4.512c.395-1.934.719-3.852 1.473-5.73.121-.309.215-.855.316-1.293l1.43-7.523.703-5.391c.098-1.18.238-2.449.023-3.539-.055-.297-.016-1.027-.016-1.562l-.016-2.516-.187-4.605c-.043-1.437-.125-2.68-.418-3.723l-.059-5.574a7.724 7.724 0 01.039-1.453c.207-1.648.371-3.164.793-4.605l.895-2.922.691-2.102c.043-.113.035-.195-.02-.211-.246-.078-.383-.305-.691-.301-.152 0-.355.063-.641.234a4.643 4.643 0 00-.496.348c-.176.156-.363.363-.586.605-.531.566-.898.926-1.348 1.918-.121.332-.367.855-.504 1.051-.648 1.012-1.027 2.508-1.258 3.898-.27 1.387-.473 2.723-.566 4.086-.043.598-.094 1.344-.023 1.82.313 2.516.441 4.949.492 7.402l.137 2.184.148 7.449c-.047 1.234-.254 2.5-.324 3.68-.117 2.012-.391 3.902-.91 5.754-.098.359-.164.832-.242 1.25l-.883 4.273-.707 2.973-.609 2.402-.602 2.207c-1.465 5.73-1.434 9.473-1.109 11.547.332 2.102.852 2.648 1.098 2.676" />
            <path d="M322.734 333.996c-.133-.574-.641-.887-1.426-1.121-1.324-.395-2.117-.137-3.207.031-.582.082-1.18.281-1.75.449-.734.227-1.441.531-2.23.371-.129-.023-.328.043-.492.074l-2.805.324c-.66.023-1.312-.078-1.969-.129-.426-.027-.871-.16-1.285.043-.109.055-.375-.008-.566-.027-.305-.031-.602-.102-.898-.156-.547-.109-1.117-.199-1.617-.402-.496-.184-.918-.34-1.363-.234-.629-.41-1.187-.758-1.934-.812a1.462 1.462 0 01-.523-.191c-.551-.336-1.121-.527-1.684-.773-.984-.445-1.664-.258-2.441-.215-.062.004-.121.039-.145.082-.234.422-.75.68-.148 1.57.176.266.242.5.621.703a1.06 1.06 0 01.352.305c.254.461.797.742 1.289 1.043l1.434.941c.219.125.492.285.699.313 1.09.129 2.039.535 3.047.906.285.117.621.168.934.223 1.086.191 2.172.285 3.258.352.539.043 1.094.172 1.613.145.883-.066 1.715-.086 2.563.02.16.02.367-.02.551-.051l1.844-.312 1.258-.246 1.012-.187.934-.121c2.371-.418 3.66-1.078 4.352-1.629s.785-1.035.727-1.285m-60.434 7.594c.555-.215.414-1.324-.172-3.105-.98-3.004-2.211-4.867-3.48-7.422l-2.02-4.195c-.789-1.789-1.516-3.598-1.574-5.535 0-.312-.148-.824-.184-1.246-.309-2.352-.215-4.727.492-6.918.473-1.543 1.367-2.945 2.328-4.426.629-.965 1.426-1.969 1.844-3.055.117-.289.547-.934.828-1.422l1.313-2.32c.398-.715.723-1.48 1.086-2.219l.965-2.234c.605-1.422 1.027-2.734 1.117-3.918.762-1.992 1.242-3.961 1.266-6.094-.008-.465.074-1.125.125-1.66.227-1.914.125-3.719-.031-5.512-.332-3.203-1.203-4.324-1.945-5.703-.062-.109-.133-.152-.176-.117-.434.328-1.012-.055-.949 2.375-.023.719-.098 1.168.023 2.152.039.316.059.852.023 1.063-.207 1.086-.133 2.457-.227 3.777l-.227 1.926-.34 1.895-.301 1.707c-.176 2.426-.914 4.75-1.906 6.977l-.859 2.031a40.67 40.67 0 01-3.664 6.668c-.719 1.094-1.602 2.211-2.219 3.418-1.082 2.047-1.844 4.258-2.34 6.477-.113.43-.109.996-.156 1.496-.078 1.699.063 3.375.34 5.004.188 1.121.453 2.227.766 3.309l.828 2.57.852 2.309c1.227 2.91 2.547 5.02 3.613 6.629 1.082 1.613 1.965 2.734 2.656 3.531 1.391 1.594 2.059 1.883 2.305 1.789M107.203 226.57c-.574-.145-1.102.359-1.73 1.242-1.082 1.473-1.375 2.621-1.992 4.105-.336.789-.609 1.672-.902 2.504-.363 1.074-.676 2.168-1.418 3.082-.121.148-.223.453-.328.684l-1.934 3.906-1.586 2.68c-.34.59-.766 1.188-.859 1.848-.023.18-.25.535-.398.805l-.719 1.266-1.344 2.305c-.461.703-.832 1.348-.941 2.012-.727.926-1.355 1.82-1.684 2.957-.074.246-.234.57-.391.82-.555.891-.918 1.809-1.305 2.723-.687 1.621-.484 2.496-.426 3.488.004.078.043.137.094.145.484.105.809.613 1.758-.48.277-.32.551-.469.773-1.008.074-.176.242-.441.344-.523.531-.434.871-1.18 1.277-1.844l1.289-1.906c.184-.281.426-.629.512-.895.449-1.391 1.207-2.598 2.023-3.805.234-.348.441-.754.641-1.145l2.082-3.996 1.133-1.93c.516-1.109 1.074-2.129 1.77-3.094.137-.184.246-.457.355-.695l1.109-2.426.75-1.691.609-1.375.59-1.242c1.41-3.273 1.648-5.488 1.57-6.758-.094-1.289-.48-1.691-.723-1.758m59.415 165.468c.691.035.012-2.578-.25-7.187-.156-3.91.008-7.289.18-10.668l.602-10.641c.191-4.16.086-8.781-.613-13.035-.84-5.453-2.254-10.531-2.352-15.754l-.176-3.457c-.164-6.578.625-13.234 1.438-19.945.566-4.742 1.242-9.508 1.418-14.398.152-3.207.121-6.59-.148-9.43-.078-.773-.066-2.687-.027-4.059a46.37 46.37 0 01.555-6.41 54.66 54.66 0 013.18-11.418l3.816-9.293c2.402-4.719 4.777-9.117 6.641-14.199l1.512-3.965c1.754-4.582 2.883-9.109 3.398-13.758.43-4.152.109-7.078-.359-9.371l-.398-1.621c-.141-.508-.324-.988-.48-1.453-.297-.945-.719-1.801-1.105-2.707-.125-.289-.223-.406-.25-.324-.141.383-.422.293-.496.891-.035.297-.016.762.098 1.527.031.785.254 1.859.336 3.426.137 1.836.023 2.984.039 5.559-.027.836-.121 2.223-.262 2.762-.539 2.766-1.219 6.332-2.281 9.664-1.043 3.313-2.379 6.414-3.828 9.566l-1.961 4.246c-2.539 6.055-5.598 11.879-8.086 18.227-.691 1.828-1.383 3.875-1.891 5.883-.914 3.43-1.527 7.004-1.684 10.57-.184 3.555-.035 7.043.016 10.461.074 3.395-.191 6.832-.418 10.078-.383 5.516-1.152 10.762-1.891 16.102a65.112 65.112 0 00-.336 3.563c-.312 4.051-.461 8.148-.199 12.27.172 2.848.582 5.676 1.059 8.43l1.137 6.578c.309 1.996.547 3.953.68 5.922.254 3.785.148 7.254.043 10.398l-.273 8.492c-.059 5.051.297 8.879.891 11.641.324 1.379.59 2.504.934 3.395.305.898.574 1.582.852 2.082.512 1.008.805 1.352.945 1.363M171.68 214.73c-.535.156-.98.547-.82 1.383a1.903 1.903 0 001.109 1.332c.488.215 1.004.258 1.586.211.629-.055 1.305-.387 1.809-.922.648-.707.766-1.402 1.207-2.078.063-.109.063-.324.07-.484.055-.922-.184-1.734-.535-2.488a9.18 9.18 0 00-.41-.801l-.406-.703-1.191-.059a4.654 4.654 0 00-.746.012c-.32.031-.699.027-.926.34-.062.086-.266.117-.41.176l-.684.277c-.422.199-.828.496-1.238.797-.402.293-.699.676-.695 1.125-.547.586-.82 1.422-.52 2.121.074.152.105.367.129.547.074.645.445 1.191.93 1.629.953.77 1.668.258 2.133-.164a.26.26 0 00.074-.145c.098-.465.211-.93.141-1.277-.016-.109.063-.262-.023-.25-.027.004-.027-.031.004-.07.172-.203.102-.199.105-.297.008-.09.109-.195.176-.25.023-.027.082-.039.027-.062-.117-.051-.148-.09-.145-.121.039-.07.152-.121.277-.133.063-.008.102-.059.152-.102.172-.156.457-.328.793-.418.172-.043.371.055.535-.004.039-.016.078-.023.109-.035l-1.594-.754c.113.074.172.242.066.406-.027.035.016.063.027.094.055.098.094.195.113.273a.33.33 0 01.016.125c.004.02-.004.02-.004.031l-.016.012v.004h-.004l.234.207v-.004a.53.53 0 01-.129-.16c-.164-.43-.168.16-.391.309-.207.23-.703.289-.937.371m-19.647 69.734c-.535.156-.98.551-.824 1.387a1.922 1.922 0 001.109 1.332c.488.215 1.004.258 1.586.211.633-.055 1.309-.387 1.813-.922.645-.707.766-1.402 1.207-2.078.063-.109.063-.324.066-.484.059-.922-.18-1.734-.531-2.488a9.12 9.12 0 00-.41-.801l-.406-.703-1.195-.059a4.612 4.612 0 00-.742.012c-.32.031-.699.027-.93.34-.059.086-.262.117-.406.176l-.684.273c-.426.203-.828.5-1.238.801-.406.293-.699.676-.695 1.125-.547.586-.824 1.422-.52 2.117.07.152.102.371.129.551.07.645.445 1.191.93 1.629.949.77 1.668.258 2.133-.168a.237.237 0 00.074-.141c.098-.465.207-.93.141-1.281-.016-.105.063-.262-.023-.246-.027 0-.027-.031 0-.07.172-.203.105-.199.109-.297.008-.09.105-.195.176-.25.023-.027.082-.039.027-.062-.117-.051-.152-.09-.145-.125.035-.066.152-.117.273-.129.066-.008.102-.059.156-.102.172-.156.453-.328.793-.418.172-.043.371.051.535-.008l.105-.031-1.59-.758c.113.074.168.246.066.41-.027.035.016.063.027.094a1.59 1.59 0 01.113.273.44.44 0 01.016.125c0 .016-.008.02-.008.031l-.012.012h-.004v.004l.23.203a.596.596 0 01-.129-.16c-.164-.43-.168.156-.387.309-.211.23-.707.289-.937.367m-2.045 72.948c-.539.156-.984.551-.824 1.383a1.922 1.922 0 001.109 1.332c.488.219 1.004.262 1.586.211.629-.055 1.309-.383 1.809-.918.648-.711.77-1.406 1.207-2.078.063-.113.063-.328.07-.488.055-.922-.184-1.734-.531-2.488l-.414-.801-.406-.703-1.191-.055a4.596 4.596 0 00-.742.008c-.32.031-.703.027-.93.34-.062.086-.266.117-.41.176l-.684.277c-.422.199-.824.496-1.234.797-.406.293-.703.676-.699 1.125-.547.586-.82 1.422-.516 2.121.07.152.102.367.125.547.074.645.449 1.191.934 1.633.949.77 1.668.258 2.133-.168a.277.277 0 00.07-.141c.098-.465.211-.934.145-1.281-.02-.109.063-.262-.027-.25-.023 0-.023-.031.004-.07.172-.199.102-.195.105-.297.008-.09.109-.195.18-.246.02-.031.078-.043.023-.066-.125-.059-.156-.09-.133-.133.043-.07.152-.109.266-.121.063-.008.102-.055.156-.102.172-.156.453-.324.789-.414.176-.047.371.051.535-.012l.109-.031-1.59-.758c.109.078.168.246.063.41-.027.035.016.066.031.094.051.098.09.195.109.273a.29.29 0 01.016.129c.004.016-.004.02-.004.031l-.016.012h-.004l.234.207a.613.613 0 01-.129-.164c-.164-.43-.168.16-.391.309-.207.23-.703.289-.934.371M161.055 247.621c-.539.156-.984.551-.824 1.387.156.688.637 1.117 1.109 1.332.488.215 1.004.258 1.586.211.633-.059 1.309-.387 1.813-.922.645-.707.766-1.406 1.203-2.078.066-.109.063-.324.07-.488.055-.918-.184-1.734-.531-2.484a8.21 8.21 0 00-.414-.801l-.406-.707-1.191-.055a4.601 4.601 0 00-.742.008c-.32.035-.703.031-.93.344-.062.086-.266.117-.406.172l-.687.277c-.422.199-.824.496-1.234.797-.406.293-.699.676-.695 1.129-.551.582-.824 1.418-.52 2.117.07.152.102.367.129.547.07.645.445 1.195.93 1.633.949.77 1.668.258 2.133-.168a.232.232 0 00.07-.141c.098-.465.211-.93.145-1.281-.016-.105.063-.262-.023-.25-.027.004-.027-.031 0-.066.172-.203.102-.199.105-.301.012-.09.109-.195.18-.246.023-.027.078-.043.023-.062-.125-.059-.156-.09-.133-.137.043-.07.152-.105.266-.117.063-.008.102-.059.156-.105a2.01 2.01 0 01.793-.414c.172-.043.371.051.535-.008l.105-.031-1.59-.758c.113.074.168.246.066.406-.031.039.012.066.027.094a1.44 1.44 0 01.109.277.363.363 0 01.02.125c0 .016-.008.02-.008.031l-.012.012h-.004l.23.207a.762.762 0 01-.129-.16c-.164-.434-.168.156-.391.309-.207.23-.703.285-.934.367m-13.12 75.76c-.535.156-.98.547-.824 1.387.156.688.637 1.117 1.113 1.328.488.219 1 .262 1.586.211.629-.051 1.305-.387 1.809-.918.645-.711.766-1.406 1.203-2.078.066-.113.066-.328.07-.488.055-.922-.18-1.734-.531-2.484l-.41-.805-.406-.703-1.191-.055a4.65 4.65 0 00-.746.008c-.32.031-.699.027-.93.344-.059.086-.262.117-.406.172l-.684.277c-.426.199-.828.496-1.238.797-.402.293-.699.676-.695 1.129-.547.582-.824 1.418-.52 2.117.07.152.102.367.129.547.074.645.445 1.191.93 1.629.953.773 1.668.262 2.133-.164a.26.26 0 00.074-.141c.098-.465.211-.934.141-1.281-.016-.109.063-.262-.023-.25-.027.004-.027-.031.004-.066.168-.203.102-.199.105-.301.008-.09.109-.195.176-.25.023-.027.082-.039.027-.059-.117-.051-.148-.09-.145-.125.039-.07.152-.121.277-.133.063-.008.102-.059.152-.102.172-.156.453-.328.793-.414.172-.043.371.051.535-.008.039-.016.074-.023.109-.035l-1.594-.754c.113.074.172.246.066.406-.027.035.016.066.027.094.051.098.094.199.113.277.012.051.02.098.016.125.004.016-.004.02-.004.031l-.016.008-.004.004.234.207h-.004a.83.83 0 01-.129-.164c-.16-.43-.168.16-.387.313-.211.227-.707.285-.937.367m-81.135-75.481c.574.18 1.125-.941 1.75-3.016.996-3.508 1.066-6.164 1.195-9.586.082-1.844 0-3.809-.07-5.672-.113-2.398-.348-4.727-.145-7.117.031-.391-.031-1.047-.051-1.578l-.328-8.93.074-6.277c.004-1.371.152-2.824-.062-4.086-.062-.344 0-1.187.031-1.801l.172-2.902.543-5.293c.227-1.656.473-3.125.426-4.426.523-2.293.973-4.484.961-6.902 0-.523.055-1.277.109-1.891.211-2.184.117-4.281-.176-6.371-.254-1.863-.73-3.113-1.215-4.07l-.766-1.254-.82-1.074c-.086-.113-.164-.148-.199-.102-.172.223-.43.246-.559.559-.152.316-.086.879.109 2.23.074.391.078.723.105 1.086s.105.758.203 1.309c.07.355.152.949.109 1.195-.117 1.23-.012 2.793-.086 4.313-.082 1.508-.324 2.969-.551 4.473l-.273 2.031c-.098 2.887-.668 5.734-1.105 8.707l-.281 2.688-.367 9.246-.105 4.578.027 7.219c-.02.461.027 1.043.051 1.566l.262 5.305.148 3.652.059 2.941-.035 2.684.113 13.355c.129 2.398.496 3.133.746 3.211m-46.851-65.75c-.5-.242-1.273.297-1.715 1.852-.34 1.313-.156 2.523.195 3.559.359 1.047.906 1.965 1.559 2.926.711 1.039 1.637 1.969 2.551 2.777 1.156 1.012 2.352 1.84 3.332 3.023.156.191.508.426.77.633l4.582 3.328 3.293 2.277c.742.461 1.508 1.016 2.324 1.195.219.051.68.34 1.027.523l1.656.879 3.176 1.469c1.016.461 1.973.781 2.855.781 1.445.582 2.938.973 4.547.781a11.67 11.67 0 011.25-.039c1.449.027 2.801-.285 4.094-.738 1.156-.41 1.863-.937 2.359-1.441s.781-1.016 1.086-1.531c.051-.082.047-.152.004-.184-.211-.148-.312-.379-.562-.488-.25-.117-.629-.094-1.406.133-.461.125-.781.098-1.371.375a1.86 1.86 0 01-.68.172c-.75-.051-1.613.191-2.492.234-.867.047-1.711-.059-2.559-.187-.371-.055-.832-.152-1.141-.145-1.648.035-3.254-.508-4.785-1.246l-1.422-.609a47.911 47.911 0 01-4.852-2.414c-.785-.449-1.523-1.043-2.281-1.473-1.289-.73-2.453-1.531-3.496-2.496-.199-.187-.5-.371-.754-.551l-2.555-1.887-1.695-1.395-1.301-1.195c-.391-.379-.715-.766-1.066-1.148-2.672-2.957-3.363-4.836-3.734-5.965-.336-1.152-.52-1.684-.793-1.785" />
        </g>
        <g className="tickets-illustration_svg__C">
            <path d="M83.496 103.402c.223.195.504.23.871.113s.809-.387 1.285-.832a6.394 6.394 0 001.629-2.445c.34-.859.5-1.75.652-2.75.145-1.082.109-2.242-.031-3.309-.176-1.383-.559-2.652-.605-4.031-.004-.223-.133-.582-.223-.867-.473-1.645-1.102-3.184-1.707-4.691l-1.219-3.195c-.277-.684-.504-1.434-.98-1.953-.133-.141-.277-.566-.402-.867l-.543-1.43-.844-2.625c-.176-.824-.375-1.598-.703-2.098l.078-2.656c.004-.145.07-.336.168-.418a2.21 2.21 0 01.594-.445c.293-.16.715-.324 1.203-.477.879-.266 1.668-.648 2.188-1.172.535-.523.785-1.164.805-1.742.008-.09-.027-.148-.082-.156-.25-.047-.453-.195-.703-.227s-.492-.012-.941.074c-.305.047-.527-.047-1.039.145-.168.063-.492.113-.637.09-.707-.098-1.715.098-2.844.723-1.145.609-1.996 1.785-2.336 2.906-.172.5-.27 1.105-.238 1.488.094 1.004.258 1.883.438 2.754l.531 2.441a11.58 11.58 0 00.461 1.406l1.93 4.594.891 2.242c.582 1.168 1.043 2.297 1.309 3.488.051.23.184.5.273.746l.863 2.504.418 1.766.188 1.434c.043.441.004.875.016 1.313-.051 3.332-.586 5.121-.785 6.293-.223 1.16-.145 1.684.074 1.867" />
            <path d="M61.707 64.621c.516.313 1.223-.348 2.223-1.379.852-.855 1.512-1.441 2.117-1.809s1.148-.566 2.191-.68l1.855-.203 1.949-.262c1.645-.227 3.25-.535 4.922-.387.273.023.727-.047 1.094-.078l6.227-.422 2.199-.023 2.039.055a4.15 4.15 0 01.945.195l.688.211c.141.027.363.309.516.563.25.387.445.895.598 1.445.273 1.016.488 2.258.41 3.23-.074.98-.262 1.66-.332 2.309-.684.93-1.695 1.637-2.82 2.789a6.71 6.71 0 01-.992.785l-3.305 2.195-2.164 1.195c-.562.301-1.047.598-1.652.781-.094.031-.148.086-.133.137.063.246-.027.488.129.738.16.234.59.555 1.773.594.68-.008 1.16.086 2.043-.266.277-.121.758-.273.953-.312 1.035-.156 2.137-.844 3.125-1.457l2.879-1.793c.422-.281.969-.672 1.266-1.02.781-.887 1.59-1.898 2.133-3.133.543-1.219.77-2.504.82-3.723.027-.699-.059-1.449-.184-2.129-.207-1.152-.496-2.359-1.113-3.582-.586-1.191-1.719-2.5-3.246-3.043-1.465-.531-2.816-.562-3.832-.504l-5.082.098c-.328-.016-.738.035-1.105.063l-3.742.34-2.582.242-2.082.18-1.91.109-3.457.41c-1.141.223-2.32.77-3.102 1.445-1.559 1.391-1.984 2.707-2.27 3.578-.484 1.793-.195 2.379.012 2.516m-3.321-4.33c.602-.012.926-.699 1.52-1.465l1.344-1.52c.418-.441.844-.883 1.422-1.285.613-.437 1.297-.891 2-1.211.91-.418 1.988-.801 3.133-.621.184.027.496-.035.754-.051 1.438-.094 2.961-.066 4.535.012l3.398.223c.746.023 1.543.109 2.219-.141.184-.066.641-.051.973-.059l1.574-.027 2.871-.066c.906.02 1.699-.012 2.363-.273 1.234.125 2.434.168 3.57-.133.246-.066.602-.082.871-.062.961.082 1.777.105 2.461.332l1.484.531c.418.152.813.313 1.176.637.059.051.125.07.168.043.215-.125.469-.141.648-.348.168-.199.316-.672-.125-1.582-.27-.508-.41-.918-1.09-1.355l-.691-.496c-.312-.32-.762-.57-1.254-.738-.484-.164-.996-.262-1.484-.34a21.143 21.143 0 00-2.723-.277c-.383-.012-.832-.031-1.121.039-1.52.355-3.035.367-4.582.313-.441-.012-.922.027-1.383.059l-4.719.23c-.781.012-1.582-.121-2.324-.09a17.66 17.66 0 01-3.734-.258c-.242-.043-.562-.023-.848-.023l-2.969.145a22.49 22.49 0 00-2.109.305l-1.719.418a12.08 12.08 0 00-1.602.559c-1.988.922-3.25 2.254-4.008 3.461-.746 1.238-.953 2.371-.937 3.172.004.402.063.73.152.992a1.8 1.8 0 00.277.594c.199.281.379.359.508.359m20.723-15.081c.016.582.203 1.023.516 1.449.527.723.879.664 1.348.742.25.039.516-.027.77-.094.324-.09.637-.277.973-.016.055.043.145-.004.215-.012l1.227-.117c.289-.004.578.09.871.109.188.016.391.105.566-.129.047-.066.164-.035.25-.035l.402.027c.25.023.504.012.742.086s.441.094.621-.125c.32.203.617.336.945.09a.31.31 0 01.254-.047c.289.07.566-.039.844-.125.496-.156.707-.742.969-1.258a.33.33 0 00.027-.152c-.02-.477.086-1-.301-1.324-.117-.098-.184-.27-.352-.215-.055.02-.145-.004-.18-.055-.172-.266-.406-.215-.629-.266s-.434-.164-.652-.234c-.094-.031-.215-.082-.293-.031-.422.258-.824.164-1.238.02-.121-.039-.254-.027-.379-.023l-1.293.078c-.215.008-.437-.117-.645-.07-.348.078-.68.078-1.02-.078-.062-.031-.145 0-.219.012l-.75.125-.52.066a2.48 2.48 0 01-.418.016c-.125-.004-.254-.043-.383-.051-1.977-.109-2.285 1.121-2.27 1.637m118.932-5.602c.234-.543-.141-1.117-.996-1.82-1.461-1.141-2.754-1.32-4.348-1.605-.863-.156-1.797-.18-2.668-.176-1.129 0-2.219.137-3.309-.164-.18-.051-.484-.016-.73-.02-1.375 0-2.738.031-4.082-.016-.953-.031-1.883-.18-2.812-.27-.613-.055-1.238-.223-1.82-.035-.16.051-.527-.039-.793-.074l-1.262-.219c-.762-.164-1.551-.301-2.242-.578-.691-.234-1.262-.48-1.855-.441-.891-.508-1.582-.977-2.41-1.223a1.463 1.463 0 01-.535-.348c-.496-.527-.895-.887-1.168-1.445l-.609-1.172c-.184-.348-.359-.699-.41-1.141-.008-.066-.043-.125-.094-.141-.234-.07-.426-.234-.691-.234-.254.004-.652.188-1 1.027-.176.484-.371.828-.238 1.543.047.23.105.605.098.766-.059.816.453 1.777 1.051 2.52.57.738 1.191 1.379 1.887 1.895.305.23.691.488.98.574l2.117.68 2.02.762c.391.137.832.266 1.258.328 1.457.277 2.918.457 4.359.57.715.074 1.445.238 2.129.234 1.168-.004 2.258.035 3.34.227.211.039.484.016.723.012l2.426-.047 1.652.008 1.324.059 1.188.152 5.895.418c1.094-.043 1.531-.367 1.629-.605m-46.527 73.511c.273.52.773.75 1.543.793 1.293.047 2.086-.543 2.984-1.605.234-.301.434-.629.605-1.082a4.44 4.44 0 00.246-1.281c.027-.543-.059-1.066-.195-1.59a9.236 9.236 0 00-.617-1.691c-.098-.199-.371-.445-.602-.625a3.729 3.729 0 00-.93-.535 4.1 4.1 0 00-.914-.238 5.675 5.675 0 00-.723-.051c-.426-.004-.75.02-.969.008-.117-.008-.133-.02-.176-.035a.25.25 0 01-.094-.066c-.012-.008-.012-.02-.016-.027.012-.02-.004.02-.039.07l-.086.133a1.58 1.58 0 01-.352.375c-.129.098-.168.066-.043.059-.109.004-.004-.016.211.105l.117.066a1.63 1.63 0 01.203.145l.063.047v-.004h.008s.016-.012.023-.02.016-.012.023-.023l.082-.062.332-.227.676-.437a4.68 4.68 0 001.465-1.898c.285-.652.242-1.379-.187-1.816-.109-.5-.301-.84-.594-1.129-.43-.23-1.109-.348-1.719-.422a4.074 4.074 0 01-.898-.215l-.734-.234c-.148-.043-.195-.043-.227-.047l-.016.004h-.004c0 .004.008-.023-.016.059l-.168.512c-.168.445-.277.48-.223.445a.55.55 0 01.27-.082c.211-.008.176.035.055-.043l.32.207-.023-.02c-.02-.02-.031-.039-.047-.062a.66.66 0 01-.062-.176c-.047-.27-.012-.625.063-.969a.196.196 0 00-.035-.156c-.152-.184-.258-.414-.434-.574-.184-.152-.41-.301-.977-.066-.328.18-.684.191-.977.949-.082.23-.176.617-.227.789-.145.41-.125 1.09.387 1.711.258.305.598.516.859.621s.465.156.598.195c.16.078.098.176.082.242-.008.027-.051.066.012.027.164-.105.309-.121.32-.066s-.113.125-.23.137c-.066.004-.051.012-.051.023s-.008.035-.02.07c-.234.211-1.176 1.117-1.156 2.375-.012.563.168 1.227.492 1.699a2.72 2.72 0 001.07.957c.617.293 1.18.406 1.742.469.473.043.836.07 1.09.16.094.035.199.008.262.008.117 0 .063-.023.094-.035.02-.016.035-.016.07-.023.012 0 .039.012.039.012.02.016.051.063.066.117a.603.603 0 01.039.32 1.008 1.008 0 01-.109.297c-.039.098-.062.137-.113.227-.051.098-.117.191-.176.285-.125.191-.273.379-.414.566-.289.367-.551.715-.723 1.027-.355.625-.324 1.098-.199 1.324m39.316-29.573c.258-.527.242-1.016.02-1.578-.395-.949-.949-1.082-1.602-1.316-.355-.141-.766-.16-1.148-.148-.496-.012-.973.152-1.441-.156-.074-.051-.211-.008-.32-.004-.609.016-1.211.105-1.812.156-.422.055-.859 0-1.285.059-.277.043-.598.012-.793.293-.055.078-.227.098-.348.129l-.578.133c-.359.086-.703.234-1.062.285-.348.059-.645.172-.789.48-.512.016-.984.125-1.273.578a.623.623 0 01-.293.242c-.406.168-.672.508-.937.82-.477.566-.273 1.223-.16 1.805a.248.248 0 00.078.133c.355.32.648.762 1.203.699.164-.02.332.059.434-.109.035-.051.133-.094.191-.078.324.094.484-.113.715-.211.23-.09.484-.117.719-.184.105-.023.242-.043.293-.125.262-.453.73-.551 1.191-.59.137-.008.266-.066.391-.121.43-.176.875-.348 1.332-.449.23-.047.484.012.699-.055.363-.129.734-.168 1.102-.016.07.023.16-.012.238-.027l.809-.105.566-.012a1.76 1.76 0 01.449.047c.137.031.266.094.398.125 1.012.285 1.664.234 2.141.063.48-.18.766-.527.875-.762m32.997-.685a2.06 2.06 0 00.188-1.535c-.23-.922-.691-1.051-1.215-1.305-.285-.145-.625-.176-.949-.18-.414-.031-.824.098-1.184-.234-.059-.055-.176-.023-.266-.027-.508-.027-1.016.008-1.52-.004-.352.008-.711-.09-1.07-.086-.234.004-.496-.066-.684.188-.051.07-.195.063-.301.078l-.492.047c-.305.031-.605.117-.91.105-.297 0-.555.059-.699.332-.434-.078-.844-.066-1.125.313a.486.486 0 01-.266.172c-.359.074-.613.336-.867.574-.453.426-.332 1.074-.277 1.641a.34.34 0 00.063.145c.285.379.512.859.996.934.141.023.281.137.383.004.035-.039.117-.059.172-.027.266.156.418.004.621-.039s.418-.008.617-.02c.09-.004.203.008.254-.062.25-.383.641-.395 1.023-.352.113.02.223-.02.328-.051.367-.102.738-.203 1.117-.246.191-.016.395.078.574.035.305-.086.605-.086.891.098.055.031.129.004.195-.004l.668-.043.457.02a1.42 1.42 0 01.363.066c.109.035.207.105.313.141.801.309 1.348.258 1.773.078a1.78 1.78 0 00.828-.754" />
        </g>
    </svg>
);

TicketsIllustrationSvg.displayName = 'TicketsIllustrationSvg';
export default TicketsIllustrationSvg;
